import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  FiSearch,
  FiX,
  FiPlus,
  FiMinus,
  FiShoppingCart,
  FiMapPin,
  FiNavigation,
  FiPackage,
  FiCheckCircle,
  FiHome,
  FiGrid,
  FiList,
  FiChevronDown,
  FiChevronRight,
  FiFolder,
  FiTag,
  FiZap,
  FiStar,
  FiFileText,
  FiShare2,
} from 'react-icons/fi';
import axios from 'axios';
import MapaUbicacion from 'shared/components/MapaUbicacion';
import VisorImagen from 'shared/components/VisorImagen';
import { getImagenUrl, getImagenFallbackUrl, getSchemaName } from 'shared/api';
import { empresaUrl } from 'shared/config';
import useWindowSize from 'shared/hooks/useWindowSize';
import { etiquetaTotal } from 'shared/etiquetaUtils';
import { firmaProductos } from 'shared/cartUtils';
import { fmtMonto } from 'shared/format';
import { useToast } from './catalogo/hooks/useToast';
import { useTasa } from './catalogo/hooks/useTasa';
import { useLocalStorageKeys } from './catalogo/hooks/useLocalStorage';
import { useProductos } from './catalogo/hooks/useProductos';
import { useCart } from './catalogo/hooks/useCart';
import { usePedidoPolling } from './catalogo/hooks/usePedidoPolling';
import { useClienteInfo } from './catalogo/hooks/useClienteInfo';
import { useCartCorporativo } from './catalogo/hooks/useCartCorporativo';
import { useSocketCliente } from './catalogo/hooks/useSocketCliente';
import { SD, S, M, cssAnimations } from './catalogo/ClienteCatalogo.styles';
import SelectorPedidos from './SelectorPedidos';
import CargarOrdenCompra from './CargarOrdenCompra';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const MODELO_PALETTE = [
  '#1a73e8', '#0d8043', '#c5221f', '#e37400', '#7b1fa2',
  '#007b83', '#9334e6', '#188038', '#d93025', '#f9ab00',
];

function CarIcon({ size = 18, color = 'currentColor', style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={style}
    >
      <path d="M3 13l1.3-4.3A2 2 0 0 1 6.2 7h11.6a2 2 0 0 1 1.9 1.7L21 13" />
      <path d="M4 13h16a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1" />
      <path d="M5 18a2 2 0 1 1 4 0" />
      <path d="M15 18a2 2 0 1 1 4 0" />
      <path d="M7 18H5a1 1 0 0 1-1-1v-2M17 18h2a1 1 0 0 0 1-1v-2" />
    </svg>
  );
}

function ClienteCatalogo({
  config,
  sessionId,
  schemaName = getSchemaName(),
  onPedidoCreado,
  pedidoInicial,
  pedidosPendientes,
  onPedidoInicialConsumido,
  onVolverInicio,
  bloqueado,
  enRevision,
  pedidoActivo,
  pedidoSeleccionadoId,
  onSeleccionarPedido,
  onNuevoPedido,
  modoNuevoPedido,
  onConfirmarPedido,
  productoInicialCodigo,
  onProductoInicialConsumido,
  verNuevosInicial,
  onVerNuevosConsumido,
}) {
  const [etapa, setEtapa] = useState(pedidoActivo ? 'catalogo' : 'seleccion_direccion');

  const [direccionesGuardadas, setDireccionesGuardadas] = useState([]);
  const [cargandoDirecciones, setCargandoDirecciones] = useState(true);
  const [mostrarGuardarDireccion, setMostrarGuardarDireccion] = useState(false);
  const [nombreDireccion, setNombreDireccion] = useState('');
  const [guardandoDireccion, setGuardandoDireccion] = useState(false);
  const ubicacionUsadaGuardada = useRef(false);

  const [cambiarDirAbierto, setCambiarDirAbierto] = useState(false);
  const [dirsCambiar, setDirsCambiar] = useState([]);
  const [cambiandoDirSel, setCambiandoDirSel] = useState(false);
  const [confirmarSedeCambio, setConfirmarSedeCambio] = useState(null);

  const [gpsCoords, setGpsCoords] = useState(null);
  const [gpsObteniendo, setGpsObteniendo] = useState(false);
  const [gpsError, setGpsError] = useState(null);
  const [mostrarMapa, setMostrarMapa] = useState(false);
  const [sede, setSede] = useState(null);
  const [direccionTexto, setDireccionTexto] = useState('');

  const [productoDetalle, setProductoDetalle] = useState(null);
  const [cantidadDetalle, setCantidadDetalle] = useState(1);
  const [cargandoDetalle, setCargandoDetalle] = useState(false);
  const [etiquetasSeleccionadas, setEtiquetasSeleccionadas] = useState([]);
  const [etiquetasManuales, setEtiquetasManuales] = useState([]);
  const [etiquetaManualInput, setEtiquetaManualInput] = useState('');
  const [galIdx, setGalIdx] = useState(0);
  const [visorOpen, setVisorOpen] = useState(null);
  const [hoveredCodigo, setHoveredCodigo] = useState(null);
  const [combos, setCombos] = useState([]);
  const [productosOferta, setProductosOferta] = useState([]);
  const [soloCombos, setSoloCombos] = useState(false);
  const [agregandoCombo, setAgregandoCombo] = useState(null);
  const [comboDetalle, setComboDetalle] = useState(null);
  const [comboSelEtiquetas, setComboSelEtiquetas] = useState({});
  const [comboImgRota, setComboImgRota] = useState({});
  const [comboGalIdx, setComboGalIdx] = useState(0);

  const { toast, mostrarToast } = useToast();
  const tasaCambio = useTasa(schemaName);
  const { ubicacionKey, carritoKey, pedidoKey, vistaKey } = useLocalStorageKeys(schemaName, sessionId);
  const [modoVista, setModoVista] = useState(() => {
    return localStorage.getItem(vistaKey) || 'grid';
  });
  useEffect(() => {
    localStorage.setItem(vistaKey, modoVista);
  }, [modoVista, vistaKey]);

  const {
    departamentos,
    categorias,
    tags,
    marcas,
    depSeleccionado,
    setDepSeleccionado,
    categoriaSeleccionada,
    seleccionarCategoria,
    tagSeleccionado,
    seleccionarTag,
    marcaSeleccionada,
    seleccionarMarca,
    setBusqueda,
    busquedaInput,
    setBusquedaInput,
    productos,
    setProductos,
    cargandoProductos,
    cursorUltimo,
    hasMore,
    cargandoMas,
    cargarProductos,
    onSearchChange,
    seleccionarDepartamento,
  } = useProductos(sede, schemaName, sessionId);

  // Etiqueta "Recién llegado" (o variantes): se resalta como anuncio destacado.
  const normalizarNombre = (s) =>
    (s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9 ]/g, '')
      .trim();
  const tagNuevo =
    tags.find((t) => {
      const n = normalizarNombre(t.nombre);
      return ['recien llegado', 'recien', 'nuevo', 'novedades', 'novedad', 'nuevos productos', 'nuevo producto', 'llegado'].includes(n);
    }) || null;

  // Si se llega desde el banner de Inicio, aplica automáticamente el filtro "Recién llegado".
  useEffect(() => {
    if (verNuevosInicial && tagNuevo) {
      seleccionarTag(tagNuevo.id);
      if (onVerNuevosConsumido) onVerNuevosConsumido();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verNuevosInicial, tagNuevo]);

  const {
    carrito,
    setCarrito,
    pedidoId,
    setPedidoId,
    setEstadoPedido: setCartEstadoPedido,
    creandoPedido,
    confirmarIniciarPedido,
    setConfirmarIniciarPedido,
    carritoRef,
    pedidoIdRef,
    syncCartToServer,
    agregarAlCarrito,
    ejecutarAgregarAlCarrito,
    eliminarDelCarrito,
    actualizarCantidad,
    irAConfirmarPedido,
    recargarDesdeServidor,
  } = useCart({
    sessionId, schemaName, sede, tasaCambio,
    pedidoInicial, pedidosPendientes, pedidoActivo,
    pedidoSeleccionadoId, onSeleccionarPedido,
    onPedidoCreado, onPedidoInicialConsumido,
    mostrarToast, ubicacionKey, carritoKey, pedidoKey,
    puedeModificarEnRevision: config?.cliente_puede_modificar_en_revision || false,
    permitirVentaAgotados: config?.permitir_venta_agotados || false,
    requiereUbicacion: config?.requiere_ubicacion_cliente !== false,
    onRequiereUbicacion: () => setEtapa('ubicacion'),
  });

  const pva = config?.permitir_venta_agotados || false;

  const { clienteId, empresaId, esCorporativo, sedes: sedesCorporativas, puedeCargarOrdenCompra } = useClienteInfo(sessionId, schemaName);

  const [cantidadesPorSede, setCantidadesPorSede] = useState({});
  const [verCarritoCorp, setVerCarritoCorp] = useState(false);
  const [verCargarOrdenCompra, setVerCargarOrdenCompra] = useState(false);
  const corporativo = useCartCorporativo({
    sessionId,
    schemaName,
    sedes: sedesCorporativas,
    tasaCambio,
    mostrarToast,
    onPedidoCreado,
    onConfirmarPedido,
  });
  const saltoUbicacionRef = useRef(!!pedidoActivo);
  const direccionesCargadasRef = useRef(false);

  const { width: ww } = useWindowSize();
  const isMobile = ww < 768;

  const [expandedGrupos, setExpandedGrupos] = useState({});
  const [mobileExpanded, setMobileExpanded] = useState({});
  const [showMobileDeptos, setShowMobileDeptos] = useState(false);

  const groupedDeptos = {};
  departamentos.forEach((d) => {
    const g = d.grupo_nombre || d.grupo || 'Sin categoría';
    if (!groupedDeptos[g]) groupedDeptos[g] = [];
    groupedDeptos[g].push(d);
  });

  const gridRef = useRef(null);
  const syncTimerRef = useRef(null);
  const headerRef = useRef(null);
  const [headerAltura, setHeaderAltura] = useState(0);
  const [ocultoPx, setOcultoPx] = useState(0);
  const [tagsExpandidas, setTagsExpandidas] = useState(false);
  const [tagIntroAbierto, setTagIntroAbierto] = useState(false);

  useEffect(() => {
    if (tags.length === 0 || etapa !== 'catalogo') return;
    const t = setTimeout(() => setTagIntroAbierto(true), 450);
    return () => clearTimeout(t);
  }, [tags.length, etapa]);

  useEffect(() => {
    const header = headerRef.current;
    if (!header) return;
    const measure = () => setHeaderAltura(header.scrollHeight);
    measure();
    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(measure);
      ro.observe(header);
      return () => ro.disconnect();
    }
  }, [tags.length, tagsExpandidas]);

  useEffect(() => {
    const el = gridRef.current;
    if (!el) return;
    setOcultoPx(0);
    let raf = null;
    let lastY = el.scrollTop;
    let oculto = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        const y = el.scrollTop;
        const delta = y - lastY;
        lastY = y;
        if (y <= 0) {
          oculto = 0;
          setOcultoPx(0);
          return;
        }
        const h = headerRef.current?.scrollHeight || 0;
        oculto = Math.max(0, Math.min(h, oculto + delta));
        setOcultoPx(oculto);
      });
    };
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      el.removeEventListener('scroll', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, [etapa]);

  const cargarDirecciones = useCallback(async () => {
    if (!sessionId) return;
    try {
      const res = await axios.get(`${API_URL}/chat/direcciones/${schemaName}/${sessionId}`);
      if (res.data.status === 'success') {
        const dirs = res.data.data || [];
        const conCoords = dirs.filter((d) => d.lat && d.lng);
        setDireccionesGuardadas(conCoords);
        direccionesCargadasRef.current = true;

        if (conCoords.length === 1) {
          const dir = conCoords[0];
          ubicacionUsadaGuardada.current = true;
          try {
            const resSede = await axios.get(
              `${API_URL}/catalogo/sede-cercana?lat=${dir.lat}&lng=${dir.lng}&schema_name=${schemaName}`
            );
            const sedeData = resSede.data.status === 'success' ? resSede.data.data : null;
            localStorage.setItem(
              ubicacionKey,
              JSON.stringify({
                lat: dir.lat,
                lng: dir.lng,
                direccion: dir.direccion,
                sede: sedeData,
              })
            );
            setSede(sedeData);
            setDireccionTexto(dir.direccion || '');
            setEtapa('catalogo');
          } catch {
            setGpsError('Error al determinar la sede de entrega.');
          }
        } else if (conCoords.length === 0 && !saltoUbicacionRef.current) {
          setEtapa('ubicacion');
        }
      }
    } catch {
      direccionesCargadasRef.current = true;
      if (!saltoUbicacionRef.current) setEtapa('ubicacion');
    } finally {
      setCargandoDirecciones(false);
    }
  }, [sessionId, schemaName, ubicacionKey]);

  const cargarSedePorCodigo = useCallback(
    async (codigo) => {
      try {
        const res = await axios.get(`${API_URL}/catalogo/sede/${codigo}?schema_name=${schemaName}`);
        if (res.data.status === 'success' && res.data.data) {
          setSede(res.data.data);
        }
      } catch {}
    },
    [schemaName]
  );

  useEffect(() => {
    if (etapa === 'seleccion_direccion' && sessionId && config?.requiere_ubicacion_cliente !== false) {
      cargarDirecciones();
    }
  }, [etapa, sessionId, cargarDirecciones, config]);

  useEffect(() => {
    if (!schemaName) return;
    let activo = true;
    axios
      .get(`${API_URL}/catalogo/combos?schema_name=${encodeURIComponent(schemaName)}${sessionId ? `&session_id=${encodeURIComponent(sessionId)}` : ''}`)
      .then((res) => {
        if (activo && res.data.status === 'success') setCombos(res.data.data || []);
      })
      .catch(() => {});
    return () => {
      activo = false;
    };
  }, [schemaName, sessionId]);

  useEffect(() => {
    if (!schemaName || !sede) return;
    let activo = true;
    axios
      .get(
        `${API_URL}/catalogo/productos?schema_name=${encodeURIComponent(schemaName)}&sede=${encodeURIComponent(sede.codigo || '0101')}&en_promocion=true&limite=50${sessionId ? `&session_id=${encodeURIComponent(sessionId)}` : ''}`
      )
      .then((res) => {
        if (activo && res.data.status === 'success') setProductosOferta(res.data.data || []);
      })
      .catch(() => {});
    return () => {
      activo = false;
    };
  }, [schemaName, sessionId, sede]);

  // Combos filtrados por la busqueda (nombre, descripcion o componentes).
  const combosFiltrados = React.useMemo(() => {
    const q = (busquedaInput || '').trim().toLowerCase();
    if (!q) return combos;
    return combos.filter((c) => {
      if ((c.nombre || '').toLowerCase().includes(q)) return true;
      if ((c.descripcion || '').toLowerCase().includes(q)) return true;
      return (c.items || []).some((it) => (it.nombre || '').toLowerCase().includes(q));
    });
  }, [combos, busquedaInput]);

  // Productos en oferta filtrados por la busqueda.
  const ofertasFiltradas = React.useMemo(() => {
    const q = (busquedaInput || '').trim().toLowerCase();
    if (!q) return productosOferta;
    return productosOferta.filter((p) => {
      if ((p.descripcion || '').toLowerCase().includes(q)) return true;
      if ((p.marca || '').toLowerCase().includes(q)) return true;
      if ((p.codigo || '').toLowerCase().includes(q)) return true;
      return false;
    });
  }, [productosOferta, busquedaInput]);

  // Prioriza los productos con etiquetas: aparecen primero en el grid/lista.
  const productosOrdenados = React.useMemo(() => {
    const conTag = [];
    const sinTag = [];
    productos.forEach((p) => {
      if ((p.tags || []).length > 0) conTag.push(p);
      else sinTag.push(p);
    });
    return conTag.concat(sinTag);
  }, [productos]);

  // Al filtrar por departamento, modelo, etiqueta o marca se sale del modo "solo promociones".
  useEffect(() => {
    if (depSeleccionado || categoriaSeleccionada || tagSeleccionado || marcaSeleccionada) setSoloCombos(false);
  }, [depSeleccionado, categoriaSeleccionada, tagSeleccionado, marcaSeleccionada]);

  // Expande los componentes del combo en instancias individuales (cantidad > 1 => una por unidad).
  const instanciasCombo = (items) => {
    const out = [];
    (items || []).forEach((it) => {
      const cant = Math.max(1, parseInt(it.cantidad, 10) || 1);
      for (let idx = 0; idx < cant; idx++) {
        out.push({ ...it, _instancia: idx });
      }
    });
    return out;
  };

  const abrirComboDetalle = (combo) => {
    const sel = {};
    instanciasCombo(combo.items).forEach((it) => {
      sel[`${it.codigo_producto}#${it._instancia}`] = (it.etiquetas || []).map((e) => e.id);
    });
    setComboSelEtiquetas(sel);
    setComboGalIdx(0);
    setComboDetalle(combo);
  };

  const cerrarComboDetalle = () => {
    setComboDetalle(null);
    setComboSelEtiquetas({});
  };

  const toggleEtiquetaCombo = (codigoProducto, instanciaIdx, et) => {
    const key = `${codigoProducto}#${instanciaIdx}`;
    setComboSelEtiquetas((prev) => {
      const actual = prev[key] || [];
      const ya = actual.includes(et.id);
      return {
        ...prev,
        [key]: ya ? actual.filter((id) => id !== et.id) : [...actual, et.id],
      };
    });
  };

  const agregarComboPersonalizado = () => {
    if (!comboDetalle) return;
    setAgregandoCombo(comboDetalle.id);
    let extra = 0;
    const componentes = instanciasCombo(comboDetalle.items).map((it) => {
      const incluidos = new Set((it.etiquetas || []).map((e) => e.id));
      const seleccionados = comboSelEtiquetas[`${it.codigo_producto}#${it._instancia}`] || [];
      const etiquetas = (it.etiquetas_disponibles || [])
        .filter((e) => seleccionados.includes(e.id))
        .map((e) => ({ id: e.id, nombre: e.nombre, precio: e.precio || 0 }));
      (it.etiquetas_disponibles || []).forEach((e) => {
        if (!incluidos.has(e.id) && seleccionados.includes(e.id)) {
          extra += e.precio || 0;
        }
      });
      return { codigo_producto: it.codigo_producto, nombre: it.nombre, etiquetas };
    });
    const prod = {
      codigo: `combo_${comboDetalle.id}`,
      combo_id: comboDetalle.id,
      nombre: comboDetalle.nombre,
      descripcion: comboDetalle.nombre,
      precio: comboDetalle.precio,
      stock: 999999,
      pesable: false,
      imagen_url: comboDetalle.imagen_url || '',
      componentes,
      combo_extra: extra,
    };
    agregarAlCarrito(prod, 1, []);
    cerrarComboDetalle();
    setTimeout(() => setAgregandoCombo(null), 500);
  };

  useEffect(() => {
    if (!config || saltoUbicacionRef.current) return;
    if (config.requiere_ubicacion_cliente === false) {
      const sedesActivas = (config.sedes || []).filter((s) => s.activa !== false);
      if (sedesActivas.length === 1) {
        const sedeData = sedesActivas[0];
        localStorage.setItem(
          ubicacionKey,
          JSON.stringify({ lat: null, lng: null, direccion: sedeData.nombre, sede: sedeData })
        );
        setSede(sedeData);
        setEtapa('catalogo');
        setCargandoDirecciones(false);
      } else if (sedesActivas.length > 1) {
        setEtapa('seleccion_sede');
        setCargandoDirecciones(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config]);

  // Inicializa la sede desde el pedido activo cuando aun no hay sede (no depende
  // de pedidoIdRef, que ahora se pre-popula desde pedidoSeleccionadoId). Sin sede
  // el catalogo no carga productos y no se puede armar pedido.
  useEffect(() => {
    if (pedidoActivo && !pedidoInicial && !sede) {
      saltoUbicacionRef.current = true;
      if (pedidoActivo.codigo_sede) {
        setSede({ codigo: pedidoActivo.codigo_sede, nombre: '' });
        cargarSedePorCodigo(pedidoActivo.codigo_sede);
      }
    }
  }, [pedidoActivo, pedidoInicial, sede, cargarSedePorCodigo]);

  // Hook useProductos maneja departamentos, useTasa maneja tasa, useCart maneja localStorage

  // ── Polling + Socket ──
  const { estadoPedido: pollingEstadoPedido, setEstadoPedido, markSocketUpdated } = usePedidoPolling(
    pedidoId, pedidoIdRef, sessionId, schemaName
  );
  useSocketCliente(clienteId, empresaId, pedidoIdRef, (data) => {
    markSocketUpdated();
    if (data.estado) {
      setEstadoPedido(data.estado);
      setCartEstadoPedido(data.estado);
      if (!data.productos) recargarDesdeServidor();
    }
    if (data.productos && Array.isArray(data.productos)) {
      // Si es el eco de nuestro propio sync-cart (mismos productos), no reaplicamos
      // el carrito: evita el loop de notificaciones/sonido en pedidos 'pendiente'.
      if (firmaProductos(data.productos) === firmaProductos(carritoRef.current)) return;
      const stockExistente = {};
      (carritoRef.current || []).forEach(c => {
        if (c.codigo && c.stock && c.stock !== 99 && c.stock !== 999) {
          stockExistente[c.codigo] = c.stock;
        }
      });
      const prods = data.productos.map(p => ({
        codigo: p.codigo || '',
        nombre: p.nombre || '',
        precio: parseFloat(p.precio || 0),
        cantidad: p.cantidad || 1,
        stock: stockExistente[p.codigo] || 99,
        pesable: p.pesable || false,
        imagen_url: p.imagen_url || '',
        departamento: '',
        etiquetas: p.etiquetas || [],
        etiquetas_extra: p.etiquetas_extra || 0,
        combo_id: p.combo_id || null,
        componentes: p.componentes || null,
      }));
      setCarrito(prods);
      carritoRef.current = prods;
    }
  }, mostrarToast);

  // Sincronizar estadoPedido del polling con el estado del carrito
  useEffect(() => {
    if (pollingEstadoPedido) {
      setEstadoPedido(pollingEstadoPedido);
      setCartEstadoPedido(pollingEstadoPedido);
    }
  }, [pollingEstadoPedido, setEstadoPedido, setCartEstadoPedido]);

  useEffect(() => {
    if (!pedidoActivo && pedidoId) {
      setPedidoId(null);
      setCartEstadoPedido(null);
    }
  }, [pedidoActivo, pedidoId, setPedidoId, setCartEstadoPedido]);

  useEffect(() => {
    if (!pedidoIdRef.current || carrito.length === 0) return;
    if (syncTimerRef.current) clearTimeout(syncTimerRef.current);
    syncTimerRef.current = setTimeout(() => {
      syncCartToServer();
    }, 500);
    return () => {
      if (syncTimerRef.current) clearTimeout(syncTimerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [carrito, pedidoId]);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    return () => {
      const pid = pedidoIdRef.current;
      const cart = carritoRef.current;
      if (pid && cart.length > 0) {
        const total = cart.reduce((s, c) => {
          const base = c.pesable ? (c.precio * c.cantidad) / 1000 : c.precio * c.cantidad;
          const extra = (c.etiquetas || []).reduce((t, e) => t + (e.precio || 0), 0);
          return s + base + (c.etiquetas_extra || extra);
        }, 0);
        const productos = cart.map((c) => ({
          codigo: c.codigo || '',
          nombre: c.nombre || '',
          precio: c.precio || 0,
          cantidad: c.cantidad || 1,
          pesable: c.pesable || false,
          subtotal: (c.pesable ? (c.precio * c.cantidad) / 1000 : c.precio * c.cantidad) + (c.etiquetas_extra || 0),
          imagen_url: c.imagen_url || '',
          etiquetas: (c.etiquetas || []).map(e => ({ id: e.id, nombre: e.nombre, precio: e.precio || 0 })),
          etiquetas_extra: c.etiquetas_extra || 0,
          combo_id: c.combo_id || null,
          componentes: c.componentes || null,
        }));
        fetch(`${API_URL}/pedidos/${pid}/sync-cart`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ schema_name: schemaName, productos, total }),
          keepalive: true,
        }).catch(() => {});
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  // ── Address / GPS / Sede (se preserva en el componente principal) ──

  const seleccionarDireccionGuardada = async (direccion) => {
    ubicacionUsadaGuardada.current = true;
    try {
      const resSede = await axios.get(
        `${API_URL}/catalogo/sede-cercana?lat=${direccion.lat}&lng=${direccion.lng}&schema_name=${schemaName}`
      );
      const sedeData = resSede.data.status === 'success' ? resSede.data.data : null;
      localStorage.setItem(
        ubicacionKey,
        JSON.stringify({
          lat: direccion.lat,
          lng: direccion.lng,
          direccion: direccion.direccion,
          sede: sedeData,
        })
      );
      setSede(sedeData);
      setDireccionTexto(direccion.direccion || '');
      setEtapa('catalogo');
    } catch {
      setGpsError('Error al determinar la sede de entrega.');
    }
  };

  const abrirCambiarDireccion = async () => {
    setCambiarDirAbierto(true);
    try {
      const res = await axios.get(`${API_URL}/chat/direcciones/${schemaName}/${sessionId}`);
      if (res.data.status === 'success') {
        setDirsCambiar((res.data.data || []).filter((d) => d.lat && d.lng));
      }
    } catch {
      setDirsCambiar([]);
    }
  };

  const seleccionarDirCambio = async (dir) => {
    setCambiandoDirSel(true);
    try {
      const resSede = await axios.get(
        `${API_URL}/catalogo/sede-cercana?lat=${dir.lat}&lng=${dir.lng}&schema_name=${schemaName}`
      );
      const sedeNueva = resSede.data.status === 'success' ? resSede.data.data : null;
      const sedeCodigoNuevo = sedeNueva?.codigo || '0101';
      const sedeCodigoActual =
        sede?.codigo || localStorage.getItem(`agorax_sede_${schemaName}`) || '0101';

      if (pedidoId && sedeCodigoNuevo !== sedeCodigoActual) {
        setConfirmarSedeCambio({ dir, sedeNueva });
      } else {
        await aplicarCambioDireccion(dir, sedeNueva);
      }
    } catch {
      mostrarToast('Error al seleccionar la dirección');
    } finally {
      setCambiandoDirSel(false);
    }
  };

  const aplicarCambioDireccion = async (dir, sedeNueva) => {
    const ubicacionData = {
      lat: dir.lat,
      lng: dir.lng,
      direccion: dir.direccion,
      sede: sedeNueva,
    };
    localStorage.setItem(ubicacionKey, JSON.stringify(ubicacionData));
    if (sedeNueva) {
      setSede(sedeNueva);
      localStorage.setItem(`agorax_sede_${schemaName}`, sedeNueva.codigo);
    }
    setDireccionTexto(dir.direccion || '');
    setCambiarDirAbierto(false);
    setConfirmarSedeCambio(null);

    if (pedidoId) {
      try {
        await axios.put(`${API_URL}/pedidos/${pedidoId}/cambiar-direccion`, {
          schema_name: schemaName,
          direccion_id: dir.id,
        });
      } catch {
        mostrarToast('Error al actualizar el pedido');
      }
    }
    if (sedeNueva && sedeNueva.codigo !== (sede?.codigo || '')) {
      setDepSeleccionado(null);
      setProductos([]);
      cargarProductos(true);
    }
  };

  const cancelarEIniciarNuevo = async () => {
    if (!confirmarSedeCambio) return;
    const { dir, sedeNueva } = confirmarSedeCambio;
    if (pedidoId) {
      try {
        await axios.put(`${API_URL}/pedidos/${pedidoId}/cancelar?schema_name=${schemaName}`);
      } catch {}
      setPedidoId(null);
      localStorage.removeItem(pedidoKey);
      setCarrito([]);
      localStorage.removeItem(carritoKey);
    }
    setConfirmarSedeCambio(null);
    await aplicarCambioDireccion(dir, sedeNueva);
  };

  const usarUbicacionGPS = () => {
    if (!navigator.geolocation) {
      setGpsError('Tu navegador no soporta geolocalización.');
      return;
    }
    setGpsObteniendo(true);
    setGpsError(null);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        setGpsObteniendo(false);
        await confirmarUbicacion(pos.coords.latitude, pos.coords.longitude, 'Ubicacion actual');
      },
      (err) => {
        setGpsObteniendo(false);
        if (err.code === 1)
          setGpsError('Permiso de ubicación denegado. Concede el permiso e intenta de nuevo.');
        else setGpsError('No se pudo obtener tu ubicación. Intenta de nuevo.');
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  };

  const abrirMapa = () => {
    setMostrarMapa(true);
    setGpsError(null);
    setGpsCoords(null);
    const sedeDefault = (config?.sedes || []).find((s) => s.activa !== false && s.lat && s.lng);
    const centroDefault = sedeDefault
      ? { lat: sedeDefault.lat, lng: sedeDefault.lng }
      : { lat: 10.4806, lng: -66.9036 }; // Caracas
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          setGpsCoords({ lat: pos.coords.latitude, lng: pos.coords.longitude });
        },
        () => {
          // Sin permiso o timeout: abrir el mapa en una ubicacion por defecto
          // para que el cliente pueda arrastrar el pin manualmente (iPhone).
          setGpsCoords(centroDefault);
          setGpsError('No obtuvimos tu ubicación automáticamente. Arrastra el pin a tu dirección.');
        },
        { enableHighAccuracy: true, timeout: 8000, maximumAge: 60000 }
      );
    } else {
      setGpsCoords(centroDefault);
      setGpsError('Tu navegador no soporta geolocalización. Arrastra el pin a tu dirección.');
    }
  };

  const confirmarUbicacion = async (lat, lng, descripcion) => {
    ubicacionUsadaGuardada.current = false;
    try {
      const resSede = await axios.get(
        `${API_URL}/catalogo/sede-cercana?lat=${lat}&lng=${lng}&schema_name=${schemaName}`
      );
      const sedeData = resSede.data.status === 'success' ? resSede.data.data : null;

      const ubicacionData = {
        lat,
        lng,
        direccion: descripcion || 'Ubicacion seleccionada',
        sede: sedeData,
      };
      localStorage.setItem(ubicacionKey, JSON.stringify(ubicacionData));

      setSede(sedeData);
      setDireccionTexto(descripcion || 'Ubicación seleccionada');
      setEtapa('catalogo');
      setMostrarMapa(false);
      setGpsCoords(null);

      if (direccionesCargadasRef.current && direccionesGuardadas.length < 3) {
        setMostrarGuardarDireccion(true);
      }
    } catch {
      setGpsError('Error al determinar la sede de entrega.');
    }
  };

  const seleccionarSedeManual = (sedeElegida) => {
    const ubicacionData = {
      lat: sedeElegida.lat || null,
      lng: sedeElegida.lng || null,
      direccion: sedeElegida.nombre,
      sede: sedeElegida,
    };
    localStorage.setItem(ubicacionKey, JSON.stringify(ubicacionData));
    setSede(sedeElegida);
    setDireccionTexto(sedeElegida.nombre);
    setEtapa('catalogo');
  };

  const confirmarUbicacionMapa = () => {
    if (gpsCoords) {
      confirmarUbicacion(gpsCoords.lat, gpsCoords.lng, direccionTexto || 'Ubicacion en mapa');
    }
  };

  const abrirDetalle = async (codigo) => {
    setCargandoDetalle(true);
    setGalIdx(0);
    try {
      const res = await axios.get(
        `${API_URL}/catalogo/producto/${codigo}?sede=${sede?.codigo || '0101'}&schema_name=${schemaName}${sessionId ? `&session_id=${encodeURIComponent(sessionId)}` : ''}`
      );
      if (res.data.status === 'success') {
        setProductoDetalle(res.data.data);
        const enCarrito = carrito.find((c) => c.codigo === res.data.data.codigo);
        const stockReal = (res.data.data.stock != null) ? res.data.data.stock : 0;
        const stockMax = pva ? Infinity : (res.data.data.pesable ? stockReal * 1000 : stockReal);
        const defaultQty = res.data.data.pesable ? 500 : 1;
        setCantidadDetalle(
          enCarrito
            ? Math.min(enCarrito.cantidad, Math.max(stockMax, defaultQty))
            : Math.min(defaultQty, Math.max(stockMax, defaultQty))
        );
        if (enCarrito?.etiquetas) {
          const idsPredef = new Set((res.data.data.etiquetas || []).map((e) => e.id));
          setEtiquetasSeleccionadas(
            enCarrito.etiquetas.filter((e) => idsPredef.has(e.id)).map((e) => e.id)
          );
          setEtiquetasManuales(
            enCarrito.etiquetas
              .filter((e) => !idsPredef.has(e.id))
              .map((e) => ({ id: e.id, nombre: e.nombre }))
          );
        } else {
          setEtiquetasSeleccionadas(
            (res.data.data.etiquetas || []).filter(e => e.activa_por_defecto).map(e => e.id)
          );
          setEtiquetasManuales([]);
        }
        setEtiquetaManualInput('');
        if (esCorporativo) {
          const cantInicial = {};
          sedesCorporativas.forEach((s) => {
            cantInicial[s.id] = 0;
          });
          setCantidadesPorSede(cantInicial);
        }
      }
    } catch {
    } finally {
      setCargandoDetalle(false);
    }
  };

  const cerrarDetalle = () => {
    setProductoDetalle(null);
    setEtiquetasManuales([]);
    setEtiquetaManualInput('');
  };

  // Comparte un producto por WhatsApp: imagen + texto con el link directo al
  // articulo (abre el catalogo en ese producto). Usa Web Share API cuando el
  // navegador permite adjuntar archivos; si no, cae a un link de WhatsApp.
  const compartirProducto = async (prod) => {
    const slug = config?.slug || getSchemaName();
    const nombre = prod?.descripcion || prod?.nombre || 'Producto';
    const link = `${empresaUrl(slug)}/?producto=${encodeURIComponent(prod?.codigo || '')}`;
    const precio = prod?.precio != null ? `\nPrecio: $${fmtMonto(prod.precio)}` : '';
    const texto = `${nombre}${precio}\n\nMira este producto: ${link}`;

    // Imagen principal del articulo: la primera de la galeria (imagenes[0]),
    // luego imagen_url y por ultimo thumb_url.
    const imagenPrincipal =
      prod?.imagenes?.[0]?.url || prod?.imagen_url || prod?.thumb_url;

    // URLs candidatas para descargar la imagen: la publica (B2) y el fallback
    // servido por el API (mismo origen del backend, con CORS habilitado). El
    // fetch exige CORS y B2 puede no exponerlo; el API si lo permite.
    const candidatos = [];
    if (imagenPrincipal) {
      const pub = getImagenUrl(imagenPrincipal);
      const api = getImagenFallbackUrl(imagenPrincipal);
      if (pub) candidatos.push(pub);
      if (api && api !== pub) candidatos.push(api);
    }

    let blob = null;
    for (const url of candidatos) {
      try {
        const resp = await fetch(url);
        if (!resp.ok) continue;
        const b = await resp.blob();
        if (b && b.size > 0) {
          blob = b;
          break;
        }
      } catch {
        // siguiente candidato
      }
    }

    let files = [];
    if (blob) {
      const ext = (blob.type?.split('/')[1] || 'jpg').split('+')[0];
      files.push(new File([blob], `${prod?.codigo || 'producto'}.${ext}`, { type: blob.type }));
    }

    if (navigator.share) {
      try {
        const shareData = { title: nombre, text: texto };
        if (files.length > 0 && navigator.canShare && navigator.canShare({ files })) {
          shareData.files = files;
        }
        await navigator.share(shareData);
        return;
      } catch (e) {
        if (e && e.name === 'AbortError') return;
      }
    }

    window.open(`https://wa.me/?text=${encodeURIComponent(texto)}`, '_blank');
  };

  // Deep-link: si se llego con ?producto=CODIGO, abre el detalle de ese producto
  // en cuanto el catalogo esta en su etapa principal (ya con sede resuelta).
  const abrioProductoCompartido = useRef(false);
  useEffect(() => {
    if (!productoInicialCodigo || abrioProductoCompartido.current) return;
    if (etapa !== 'catalogo') return;
    abrioProductoCompartido.current = true;
    abrirDetalle(productoInicialCodigo);
    if (onProductoInicialConsumido) onProductoInicialConsumido();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productoInicialCodigo, etapa]);

  const agregarEtiquetaManual = () => {
    const nombre = etiquetaManualInput.trim();
    if (!nombre) return;
    setEtiquetasManuales((prev) => {
      if (prev.some((e) => e.nombre.toLowerCase() === nombre.toLowerCase())) return prev;
      return [...prev, { id: 'manual_' + Date.now().toString(36), nombre }];
    });
    setEtiquetaManualInput('');
  };

  const quitarEtiquetaManual = (id) => {
    setEtiquetasManuales((prev) => prev.filter((e) => e.id !== id));
  };

  // ── Funciones ya provistas por useCart: agregarAlCarrito, eliminarDelCarrito, etc. ──

  const guardarDireccionFrecuente = async () => {
    if (!nombreDireccion.trim()) return;
    setGuardandoDireccion(true);
    const ubicacionData = JSON.parse(localStorage.getItem(ubicacionKey) || '{}');
    try {
      await axios.post(`${API_URL}/chat/direcciones/${schemaName}/${sessionId}`, {
        session_id: sessionId,
        schema_name: schemaName,
        nombre: nombreDireccion.trim(),
        direccion: ubicacionData.direccion || 'Ubicación GPS',
        principal: direccionesGuardadas.length === 0,
        lat: ubicacionData.lat,
        lng: ubicacionData.lng,
      });
      setDireccionesGuardadas((prev) => [
        ...prev,
        {
          nombre: nombreDireccion.trim(),
          direccion: ubicacionData.direccion || 'Ubicación GPS',
          lat: ubicacionData.lat,
          lng: ubicacionData.lng,
          principal: prev.length === 0,
        },
      ]);
      setMostrarGuardarDireccion(false);
      setNombreDireccion('');
      mostrarToast('Dirección guardada correctamente');
    } catch {
      mostrarToast('Error al guardar la direccion');
    } finally {
      setGuardandoDireccion(false);
    }
  };

  const sentinelRef = useRef(null);

  useEffect(() => {
    if (!sentinelRef.current || cargandoMas || !hasMore) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          cargarProductos(false, cursorUltimo);
        }
      },
      { root: gridRef.current, rootMargin: '200px' }
    );
    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, [cargandoMas, hasMore, cursorUltimo, cargarProductos]);

  const irAConfirmarPedidoWrapper = async () => {
    cerrarDetalle();
    await irAConfirmarPedido(onConfirmarPedido);
  };

  const totalCarrito = carrito.reduce((s, c) => {
    const base = c.pesable ? (c.precio * c.cantidad) / 1000 : c.precio * c.cantidad;
    return s + base + etiquetaTotal(c);
  }, 0);

  const stockMaxCorp = productoDetalle
    ? productoDetalle.pesable
      ? (productoDetalle.stock || 0) * 1000
      : (productoDetalle.stock || 0)
    : 0;
  const totalSeleccionadoCorp = Object.values(cantidadesPorSede).reduce((s, c) => s + (Number(c) || 0), 0);
  const restanteCorp = Math.max(0, stockMaxCorp - totalSeleccionadoCorp);

  const ajusteCantidad = (prod, delta) => {
    const paso = prod.pesable ? 50 : 1;
    setCantidadDetalle((prev) => {
      if (pva) return Math.max(paso, prev + delta);
      const stockReal = (prod.stock != null) ? prod.stock : 0;
      const stockMax = prod.pesable ? stockReal * 1000 : stockReal;
      const effectiveMax = Math.max(paso, stockMax);
      const nueva = Math.min(Math.max(paso, prev + delta), effectiveMax);
      return nueva;
    });
  };

  // ──────────────── Render ────────────────
  const ubicacionActual = React.useMemo(() => {
    const d = JSON.parse(localStorage.getItem(ubicacionKey) || '{}');
    return d.direccion || 'Ubicacion seleccionada';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ubicacionKey, gpsCoords]);

  if (etapa === 'seleccion_direccion') {
    return (
      <div style={S.wrapper}>
        <div style={S.seleccionContainer}>
          <div style={S.ubicacionIcon}>
            <FiMapPin size={48} color="var(--color-secondary)" />
          </div>
          <h2 style={S.ubicacionTitle}>Donde entregamos tu pedido?</h2>
          <p style={S.ubicacionSub}>
            {cargandoDirecciones
              ? 'Cargando tus direcciones...'
              : 'Selecciona una dirección guardada o agrega una nueva.'}
          </p>

          {cargandoDirecciones ? (
            <div style={S.loadingState}>
              <div style={S.spinner} />
            </div>
          ) : direccionesGuardadas.length > 0 ? (
            <div style={{ width: '100%', maxWidth: '320px' }}>
              <div
                style={{
                  fontSize: '13px',
                  fontWeight: 600,
                  color: 'var(--color-text-secondary)',
                  marginBottom: '8px',
                }}
              >
                Usar dirección guardada:
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {direccionesGuardadas.slice(0, 5).map((dir, i) => (
                  <button
                    key={dir.id || i}
                    onClick={() => seleccionarDireccionGuardada(dir)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '12px 14px',
                      borderRadius: '14px',
                      border: dir.principal ? '2px solid #f0b400' : '1px solid var(--color-border)',
                      backgroundColor: dir.principal ? '#fffdf5' : 'var(--color-surface)',
                      cursor: 'pointer',
                      textAlign: 'left',
                      fontFamily: 'inherit',
                    }}
                  >
                    <FiHome
                      size={18}
                      color={dir.principal ? '#f0b400' : 'var(--color-secondary)'}
                      style={{ flexShrink: 0 }}
                    />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div
                        style={{ fontSize: '13px', fontWeight: 600, color: 'var(--color-text)' }}
                      >
                        {dir.nombre || 'Sin nombre'}
                        {dir.principal && (
                          <span
                            style={{
                              fontSize: '10px',
                              color: '#f0b400',
                              marginLeft: '6px',
                              fontWeight: 500,
                            }}
                          >
                            FAVORITA
                          </span>
                        )}
                      </div>
                      <div
                        style={{
                          fontSize: '11px',
                          color: 'var(--color-text-secondary)',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          marginTop: '2px',
                        }}
                      >
                        {dir.direccion}
                      </div>
                    </div>
                  </button>
                ))}
              </div>
              <button
                onClick={() => setEtapa('ubicacion')}
                style={{
                  width: '100%',
                  marginTop: '10px',
                  padding: '12px 14px',
                  borderRadius: '14px',
                  border: '1.5px solid var(--color-border)',
                  backgroundColor: 'transparent',
                  color: 'var(--color-text-secondary)',
                  fontSize: '13px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                }}
              >
                <FiMapPin size={16} />
                Nueva dirección
              </button>
            </div>
          ) : (
            <div style={S.ubicacionButtons}>
              <button
                onClick={usarUbicacionGPS}
                disabled={gpsObteniendo}
                style={S.ubicacionBtnPrimary}
              >
                <FiNavigation size={18} />
                {gpsObteniendo ? 'Obteniendo ubicación...' : 'Usar mi ubicación actual'}
              </button>
              <button onClick={abrirMapa} style={S.ubicacionBtnSecondary}>
                <FiMapPin size={18} />
                Elegir en el mapa
              </button>
            </div>
          )}
        </div>

        {gpsError && <div style={S.ubicacionError}>{gpsError}</div>}

        {mostrarMapa && (
          <div
            style={S.mapOverlay}
            onClick={() => {
              setMostrarMapa(false);
              setGpsCoords(null);
            }}
          >
            <div style={S.mapModal} onClick={(e) => e.stopPropagation()}>
              <div style={S.mapHeader}>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600 }}>
                  Selecciona tu ubicación
                </h3>
                <button
                  onClick={() => {
                    setMostrarMapa(false);
                    setGpsCoords(null);
                  }}
                  style={S.mapClose}
                >
                  <FiX size={20} />
                </button>
              </div>
              {gpsCoords ? (
                <>
                  {gpsError && <div style={S.ubicacionError}>{gpsError}</div>}
                  <div style={{ marginBottom: '12px' }}>
                    <input
                      placeholder="Describe tu direccion (ej: Av. Principal, Edif. Torre)"
                      value={direccionTexto}
                      onChange={(e) => setDireccionTexto(e.target.value)}
                      style={S.direccionInput}
                    />
                  </div>
                  <MapaUbicacion
                    lat={gpsCoords.lat}
                    lng={gpsCoords.lng}
                    readOnly={false}
                    onLocationChange={(lat, lng) => setGpsCoords({ lat, lng })}
                    height="300px"
                  />
                  <p
                    style={{
                      fontSize: '11px',
                      color: 'var(--color-text-secondary)',
                      textAlign: 'center',
                      margin: '8px 0 0',
                    }}
                  >
                    Arrastra el pin a tu ubicación exacta
                  </p>
                  <div style={S.mapActions}>
                    <button
                      onClick={() => {
                        setMostrarMapa(false);
                        setGpsCoords(null);
                      }}
                      style={S.mapBtnCancel}
                    >
                      Cancelar
                    </button>
                    <button onClick={confirmarUbicacionMapa} style={S.mapBtnConfirm}>
                      Confirmar ubicación
                    </button>
                  </div>
                </>
              ) : gpsError ? (
                <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                  <p
                    style={{ color: 'var(--color-danger)', fontSize: '13px', marginBottom: '16px' }}
                  >
                    {gpsError}
                  </p>
                  <button
                    onClick={abrirMapa}
                    style={{
                      padding: '10px 24px',
                      borderRadius: '10px',
                      border: 'none',
                      backgroundColor: 'var(--color-secondary)',
                      color: 'var(--color-surface)',
                      fontSize: '13px',
                      fontWeight: 600,
                      cursor: 'pointer',
                    }}
                  >
                    Reintentar
                  </button>
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: '50px 0' }}>
                  <div style={S.spinner} />
                  <p
                    style={{
                      marginTop: '16px',
                      fontSize: '13px',
                      color: 'var(--color-text-secondary)',
                    }}
                  >
                    Obteniendo tu ubicación...
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  if (etapa === 'seleccion_sede') {
    const sedesActivas = (config?.sedes || []).filter((s) => s.activa !== false);
    return (
      <div style={S.wrapper}>
        <div style={S.ubicacionContainer}>
          <div style={S.ubicacionIcon}>
            <FiPackage size={48} color="var(--color-secondary)" />
          </div>
          <h2 style={S.ubicacionTitle}>Selecciona tu sede</h2>
          <p style={S.ubicacionSub}>
            Elige la sede donde deseas ser atendido
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', maxWidth: '400px', margin: '0 auto', width: '100%' }}>
            {sedesActivas.map((s) => (
              <button
                key={s.codigo}
                onClick={() => seleccionarSedeManual(s)}
                style={{
                  padding: '16px 20px',
                  borderRadius: '12px',
                  border: '1px solid var(--color-border)',
                  backgroundColor: 'var(--color-surface)',
                  cursor: 'pointer',
                  textAlign: 'left',
                  transition: 'border-color 0.2s, box-shadow 0.2s',
                  fontFamily: 'inherit',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = 'var(--color-secondary)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'var(--color-border)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div style={{ fontWeight: 600, fontSize: '15px', color: 'var(--color-text)', marginBottom: '4px' }}>
                  {s.nombre}
                </div>
                {s.direccion && (
                  <div style={{ fontSize: '13px', color: 'var(--color-text-secondary)', display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <FiMapPin size={14} />
                    <span>{s.direccion}</span>
                  </div>
                )}
                {s.zona_cobertura && (
                  <div style={{ fontSize: '11px', color: 'var(--color-text-muted)', marginTop: '4px' }}>
                    Zona: {s.zona_cobertura}
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (etapa === 'ubicacion') {
    return (
      <div style={S.wrapper}>
        <div style={S.ubicacionContainer}>
          <div style={S.ubicacionIcon}>
            <FiMapPin size={48} color="var(--color-secondary)" />
          </div>
          <h2 style={S.ubicacionTitle}>Donde entregamos tu pedido?</h2>
          <p style={S.ubicacionSub}>
            Necesitamos tu ubicación para mostrarte los productos disponibles en la sede más
            cercana.
          </p>

          {gpsError && <div style={S.ubicacionError}>{gpsError}</div>}

          <div style={S.ubicacionButtons}>
            <button
              onClick={usarUbicacionGPS}
              disabled={gpsObteniendo}
              style={S.ubicacionBtnPrimary}
            >
              <FiNavigation size={18} />
              {gpsObteniendo ? 'Obteniendo ubicacion...' : 'Usar mi ubicacion actual'}
            </button>
            <button onClick={abrirMapa} style={S.ubicacionBtnSecondary}>
              <FiMapPin size={18} />
              Elegir en el mapa
            </button>
            {(config?.sedes || []).filter((s) => s.activa !== false).length > 0 && (
              <button onClick={() => setEtapa('seleccion_sede')} style={S.ubicacionBtnSecondary}>
                <FiPackage size={18} />
                Seleccionar sede
              </button>
            )}
          </div>
        </div>

        {mostrarMapa && (
          <div
            style={S.mapOverlay}
            onClick={() => {
              setMostrarMapa(false);
              setGpsCoords(null);
            }}
          >
            <div style={S.mapModal} onClick={(e) => e.stopPropagation()}>
              <div style={S.mapHeader}>
                <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600 }}>
                  Selecciona tu ubicación
                </h3>
                <button
                  onClick={() => {
                    setMostrarMapa(false);
                    setGpsCoords(null);
                  }}
                  style={S.mapClose}
                >
                  <FiX size={20} />
                </button>
              </div>
              {gpsCoords ? (
                <>
                  {gpsError && <div style={S.ubicacionError}>{gpsError}</div>}
                  <div style={{ marginBottom: '12px' }}>
                    <input
                      placeholder="Describe tu direccion (ej: Av. Principal, Edif. Torre)"
                      value={direccionTexto}
                      onChange={(e) => setDireccionTexto(e.target.value)}
                      style={S.direccionInput}
                    />
                  </div>
                  <MapaUbicacion
                    lat={gpsCoords.lat}
                    lng={gpsCoords.lng}
                    readOnly={false}
                    onLocationChange={(lat, lng) => setGpsCoords({ lat, lng })}
                    height="300px"
                  />
                  <p
                    style={{
                      fontSize: '11px',
                      color: 'var(--color-text-secondary)',
                      textAlign: 'center',
                      margin: '8px 0 0',
                    }}
                  >
                    Arrastra el pin a tu ubicación exacta
                  </p>
                  <div style={S.mapActions}>
                    <button
                      onClick={() => {
                        setMostrarMapa(false);
                        setGpsCoords(null);
                      }}
                      style={S.mapBtnCancel}
                    >
                      Cancelar
                    </button>
                    <button onClick={confirmarUbicacionMapa} style={S.mapBtnConfirm}>
                      Confirmar ubicación
                    </button>
                  </div>
                </>
              ) : gpsError ? (
                <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                  <p
                    style={{ color: 'var(--color-danger)', fontSize: '13px', marginBottom: '16px' }}
                  >
                    {gpsError}
                  </p>
                  <button
                    onClick={abrirMapa}
                    style={{
                      padding: '10px 24px',
                      borderRadius: '10px',
                      border: 'none',
                      backgroundColor: 'var(--color-secondary)',
                      color: 'var(--color-surface)',
                      fontSize: '13px',
                      fontWeight: 600,
                      cursor: 'pointer',
                    }}
                  >
                    Reintentar
                  </button>
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: '50px 0' }}>
                  <div style={S.spinner} />
                  <p
                    style={{
                      marginTop: '16px',
                      fontSize: '13px',
                      color: 'var(--color-text-secondary)',
                    }}
                  >
                    Obteniendo tu ubicación...
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  }

  // ──────────────── Catálogo ────────────────
  const pedidoEnEdicion =
    (pedidosPendientes || []).find((p) => parseInt(p.id) === parseInt(pedidoId)) || pedidoActivo;

  return (
    <div style={{ ...S.wrapper, flexDirection: isMobile ? 'column' : 'row' }}>
      {/* Sidebar de departamentos - Desktop */}
      {!isMobile && (
        <div style={SD.sidebar}>
          {esCorporativo && puedeCargarOrdenCompra && (
            <div style={{ padding: '12px 12px 4px' }}>
              <button
                onClick={() => setVerCargarOrdenCompra(true)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  width: '100%',
                  padding: '10px 12px',
                  borderRadius: '10px',
                  border: '1.5px dashed var(--color-secondary)',
                  background: 'var(--color-surface)',
                  color: 'var(--color-secondary)',
                  fontSize: '12px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                }}
              >
                <FiFileText size={16} />
                <span style={{ flex: 1, textAlign: 'left' }}>Cargar orden de compra</span>
              </button>
            </div>
          )}
          {combos.length > 0 && (
            <div style={{ padding: '16px 12px 4px' }}>
              <button
                onClick={() => {
                  setSoloCombos((v) => !v);
                  if (!soloCombos) {
                    setDepSeleccionado(null);
                    seleccionarCategoria(categoriaSeleccionada);
                  }
                }}
                style={{
                  ...SD.sidebarItem,
                  background: soloCombos
                    ? 'linear-gradient(135deg, #c5221f 0%, #ea4335 100%)'
                    : 'linear-gradient(135deg, #fde7e7 0%, #fbe0e0 100%)',
                  color: soloCombos ? '#fff' : '#c5221f',
                  fontWeight: 700,
                  boxShadow: soloCombos ? '0 4px 12px rgba(197,34,31,0.35)' : 'none',
                }}
              >
                <div
                  style={{
                    width: '28px',
                    height: '28px',
                    borderRadius: '8px',
                    background: soloCombos ? 'rgba(255,255,255,0.22)' : '#c5221f18',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  <FiZap size={15} />
                </div>
                <span style={{ flex: 1 }}>Promociones</span>
                <span
                  style={{
                    fontSize: '10px',
                    fontWeight: 700,
                    padding: '1px 7px',
                    borderRadius: '10px',
                    background: soloCombos ? 'rgba(255,255,255,0.25)' : '#c5221f18',
                  }}
                >
                  {combos.length}
                </span>
              </button>
            </div>
          )}
          {tags.length > 0 && (
            <div style={{ padding: '14px 12px', borderBottom: '1px solid var(--color-border)' }}>
              <div
                style={{
                  ...SD.sidebarTitle,
                  padding: '0 0 10px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                <FiStar size={13} color="var(--color-secondary)" />
                Etiquetas
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {tags.map((t) => {
                  const sel = tagSeleccionado === t.id;
                  const esNuevo = tagNuevo && tagNuevo.id === t.id;
                  return (
                    <button
                      key={t.id}
                      onClick={() => seleccionarTag(t.id)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '8px 10px',
                        borderRadius: '10px',
                        fontSize: '12px',
                        fontWeight: sel ? 700 : esNuevo ? 700 : 500,
                        cursor: 'pointer',
                        border: sel ? `1.5px solid ${t.color}` : esNuevo ? '1.5px solid #c5221f' : '1px solid var(--color-border)',
                        background: esNuevo && !sel
                          ? 'linear-gradient(120deg, #c5221f 0%, #ea4335 100%)'
                          : sel ? `${t.color}16` : 'var(--color-surface)',
                        color: esNuevo && !sel ? '#fff' : sel ? t.color : 'var(--color-text)',
                        boxShadow: sel ? `0 2px 8px ${t.color}30` : esNuevo ? '0 2px 10px rgba(197,34,31,0.35)' : 'none',
                        fontFamily: 'inherit',
                      }}
                    >
                      {t.icono && <span style={{ fontSize: '15px' }}>{t.icono}</span>}
                      <span style={{ flex: 1, textAlign: 'left' }}>{t.nombre}</span>
                      {esNuevo && !sel && (
                        <span style={{ fontSize: '9px', fontWeight: 800, letterSpacing: '0.5px', textTransform: 'uppercase', background: 'rgba(255,255,255,0.25)', padding: '2px 6px', borderRadius: '8px', color: '#fff' }}>
                          Nuevo
                        </span>
                      )}
                      <span
                        style={{
                          fontSize: '10px',
                          fontWeight: 700,
                          color: sel ? t.color : 'var(--color-text-muted)',
                          background: sel ? `${t.color}1a` : '#f1f3f4',
                          padding: '1px 7px',
                          borderRadius: '10px',
                        }}
                      >
                        {t.total_productos}
                      </span>
                      {sel && <FiCheckCircle size={13} color={t.color} />}
                    </button>
                  );
                })}
              </div>
            </div>
          )}
          {marcas.length > 0 && (
            <div style={{ padding: '14px 12px', borderBottom: '1px solid var(--color-border)' }}>
              <div style={{ ...SD.sidebarTitle, padding: '0 0 10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                <FiTag size={13} color="var(--color-secondary)" />
                Marcas
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {marcas.map((m) => {
                  const sel = marcaSeleccionada === m.marca;
                  return (
                    <button
                      key={m.marca}
                      onClick={() => seleccionarMarca(m.marca)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '8px 10px',
                        borderRadius: '10px',
                        fontSize: '12px',
                        fontWeight: sel ? 700 : 500,
                        cursor: 'pointer',
                        border: sel ? '1.5px solid var(--color-secondary)' : '1px solid var(--color-border)',
                        background: sel ? 'var(--color-bg-hover)' : 'var(--color-surface)',
                        color: sel ? 'var(--color-secondary)' : 'var(--color-text)',
                        fontFamily: 'inherit',
                      }}
                    >
                      <span style={{ flex: 1, textAlign: 'left' }}>{m.marca}</span>
                      <span style={{ fontSize: '10px', fontWeight: 700, color: 'var(--color-text-muted)', background: '#f1f3f4', padding: '1px 7px', borderRadius: '10px' }}>
                        {m.total_productos}
                      </span>
                      {sel && <FiCheckCircle size={13} color="var(--color-secondary)" />}
                    </button>
                  );
                })}
              </div>
            </div>
          )}
          {categorias.length > 0 && (
            <div style={{ paddingTop: '16px', borderBottom: '1px solid var(--color-border)', paddingBottom: '12px' }}>
              <div style={{ ...SD.sidebarTitle, padding: '4px 12px 10px' }}>
                Modelos
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '3px', padding: '0 12px 0' }}>
                <button
                  onClick={() => seleccionarCategoria(categoriaSeleccionada)}
                  style={{
                    ...SD.sidebarItem,
                    backgroundColor: !categoriaSeleccionada ? 'var(--color-bg-hover)' : 'transparent',
                    color: !categoriaSeleccionada ? 'var(--color-secondary)' : 'var(--color-text)',
                    fontWeight: !categoriaSeleccionada ? 600 : 400,
                    fontSize: '12px',
                  }}
                >
                  <div style={{ width: '26px', height: '26px', borderRadius: '8px', background: '#e8eaed', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <FiGrid size={13} color="#5f6368" />
                  </div>
                  <span style={{ flex: 1 }}>Todos los modelos</span>
                  {!categoriaSeleccionada && <FiCheckCircle size={14} color="var(--color-secondary)" />}
                </button>
                {categorias.map((c, idx) => {
                  const sel = categoriaSeleccionada === c.categoria;
                  const color = MODELO_PALETTE[idx % MODELO_PALETTE.length];
                  return (
                    <button
                      key={c.categoria}
                      onClick={() => seleccionarCategoria(c.categoria)}
                      style={{
                        ...SD.sidebarItem,
                        backgroundColor: sel ? `${color}10` : 'transparent',
                        color: sel ? color : 'var(--color-text)',
                        fontWeight: sel ? 600 : 400,
                        fontSize: '12px',
                        borderLeft: sel ? `3px solid ${color}` : '3px solid transparent',
                      }}
                    >
                      <div style={{ width: '26px', height: '26px', borderRadius: '8px', background: `${color}18`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <CarIcon size={14} color={color} />
                      </div>
                      <span style={{ flex: 1, wordBreak: 'break-word', lineHeight: 1.3 }}>
                        {c.categoria}
                      </span>
                      <span style={{ fontSize: '10px', fontWeight: 600, color: sel ? color : 'var(--color-text-muted)', background: sel ? `${color}18` : '#f1f3f4', padding: '1px 7px', borderRadius: '10px' }}>
                        {c.total_productos}
                      </span>
                    </button>
                  );
                })}
              </div>
            </div>
          )}
          <div style={SD.sidebarTitle}>Categorías</div>
          <div style={SD.sidebarList}>
            <button
              onClick={() => setDepSeleccionado(null)}
              style={{
                ...SD.sidebarItem,
                backgroundColor: !depSeleccionado ? 'var(--color-secondary)' : 'transparent',
                color: !depSeleccionado ? 'var(--color-surface)' : 'var(--color-primary)',
                fontWeight: !depSeleccionado ? 700 : 500,
              }}
            >
              <FiGrid size={16} />
              <span>Todos los productos</span>
            </button>
            {Object.entries(groupedDeptos)
              .sort(([a], [b]) => a.localeCompare(b))
              .map(([grupo, depts], idx) => {
                const PALETTE = [
                  '#1a73e8', '#0d8043', '#c5221f', '#e37400', '#7b1fa2',
                  '#007b83', '#1967d2', '#9334e6', '#188038', '#d93025',
                ];
                const color = PALETTE[idx % PALETTE.length];
                return (
                  <div key={grupo} style={{ marginTop: '4px' }}>
                    <button
                      onClick={() =>
                        setExpandedGrupos((prev) => ({ ...prev, [grupo]: !prev[grupo] }))
                      }
                      style={{
                        ...SD.sidebarItem,
                        fontWeight: 600,
                        fontSize: '11px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.6px',
                        color,
                        backgroundColor: 'transparent',
                        justifyContent: 'space-between',
                        borderLeft: `3px solid ${color}`,
                        paddingLeft: '12px',
                      }}
                    >
                      <span>{grupo}</span>
                      <span
                        style={{
                          fontSize: '10px',
                          fontWeight: 600,
                          background: `${color}18`,
                          color,
                          padding: '1px 7px',
                          borderRadius: '10px',
                        }}
                      >
                        {depts.length}
                        {' '}
                        <span style={{ fontSize: '9px' }}>
                          {expandedGrupos[grupo] !== false ? '▾' : '▸'}
                        </span>
                      </span>
                    </button>
                    {expandedGrupos[grupo] !== false &&
                      depts.map((d) => (
                        <button
                          key={d.codigo}
                          onClick={() => seleccionarDepartamento(d.codigo)}
                          style={{
                            ...SD.sidebarItem,
                            paddingLeft: '28px',
                            backgroundColor:
                              depSeleccionado === d.codigo
                                ? 'var(--color-bg-hover)'
                                : 'transparent',
                            color:
                              depSeleccionado === d.codigo
                                ? 'var(--color-secondary)'
                                : 'var(--color-text)',
                            fontWeight: depSeleccionado === d.codigo ? 600 : 400,
                            borderLeft:
                              depSeleccionado === d.codigo
                                ? '3px solid var(--color-secondary)'
                                : '3px solid transparent',
                          }}
                        >
                          <span>{d.nombre}</span>
                        </button>
                      ))}
                  </div>
                );
              })}
          </div>

        </div>
      )}

      {/* Contenido principal */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          minHeight: 0,
        }}
      >
        {/* Selector de pedidos activos + iniciar uno nuevo en paralelo */}
        <SelectorPedidos
          pedidos={pedidosPendientes}
          seleccionadoId={pedidoId}
          onSeleccionar={onSeleccionarPedido}
          modoNuevoPedido={!!modoNuevoPedido}
          onNuevoPedido={onNuevoPedido}
        />

        {/* Header */}
        <div style={S.catHeader}>
          <div style={S.searchRow}>
            <div style={S.searchBox}>
              <FiSearch size={16} color="var(--color-text-secondary)" />
              <input
                placeholder="Buscar productos..."
                value={busquedaInput}
                onChange={(e) => onSearchChange(e.target.value)}
                style={S.searchInput}
              />
              {busquedaInput && (
                <button
                  onClick={() => {
                    setBusquedaInput('');
                    setBusqueda('');
                  }}
                  style={S.searchClear}
                >
                  <FiX size={16} />
                </button>
              )}
            </div>
            <div style={S.vistaToggle}>
              <button
                onClick={() => setModoVista('grid')}
                title="Vista cuadrícula"
                style={modoVista === 'grid' ? S.vistaToggleBtnActive : S.vistaToggleBtn}
              >
                <FiGrid size={16} />
              </button>
              <button
                onClick={() => setModoVista('list')}
                title="Vista lista"
                style={modoVista === 'list' ? S.vistaToggleBtnActive : S.vistaToggleBtn}
              >
                <FiList size={16} />
              </button>
            </div>
          </div>

          {/* Filtros colapsables al hacer scroll */}
          <div
            ref={headerRef}
            style={{
              overflow: 'hidden',
              maxHeight:
                headerAltura > 0 ? `${Math.max(0, headerAltura - ocultoPx)}px` : undefined,
              opacity: headerAltura > 0 ? 1 - Math.min(1, ocultoPx / headerAltura) * 0.85 : 1,
            }}
          >

          {!isMobile && tags.length > 0 && (() => {
            const TAGS_VISIBLES = 8;
            const tagsVisibles = tagsExpandidas ? tags : tags.slice(0, TAGS_VISIBLES);
            const tagsOcultas = tags.length - TAGS_VISIBLES;
            return (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px',
                paddingBottom: '6px',
                marginBottom: '10px',
              }}
            >
              {tagsVisibles.map((t) => {
                const sel = tagSeleccionado === t.id;
                const esNuevo = tagNuevo && tagNuevo.id === t.id;
                return (
                  <button
                    key={t.id}
                    onClick={() => seleccionarTag(t.id)}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      padding: '7px 14px',
                      borderRadius: '20px',
                      border: sel ? `1.5px solid ${t.color}` : esNuevo ? '1.5px solid #c5221f' : '1px solid var(--color-border)',
                      background: esNuevo && !sel
                        ? 'linear-gradient(120deg, #c5221f 0%, #ea4335 100%)'
                        : sel ? `${t.color}16` : 'var(--color-surface)',
                      color: esNuevo && !sel ? '#fff' : sel ? t.color : 'var(--color-text)',
                      fontSize: '12px',
                      fontWeight: sel || esNuevo ? 700 : 500,
                      cursor: 'pointer',
                      fontFamily: 'inherit',
                      whiteSpace: 'nowrap',
                      flexShrink: 0,
                      boxShadow: sel ? `0 2px 8px ${t.color}30` : esNuevo ? '0 3px 10px rgba(197,34,31,0.35)' : 'none',
                      transition: 'all 0.15s ease',
                    }}
                  >
                    {t.icono && <span style={{ fontSize: '14px' }}>{t.icono}</span>}
                    <span>{t.nombre}</span>
                    {esNuevo && !sel && (
                      <span style={{ fontSize: '9px', fontWeight: 800, letterSpacing: '0.5px', textTransform: 'uppercase', background: 'rgba(255,255,255,0.25)', padding: '1px 6px', borderRadius: '8px' }}>
                        Nuevo
                      </span>
                    )}
                    <span
                      style={{
                        fontSize: '10px',
                        fontWeight: 700,
                        padding: '1px 6px',
                        borderRadius: '10px',
                        background: sel ? `${t.color}1a` : esNuevo ? 'rgba(255,255,255,0.25)' : 'var(--color-bg-hover)',
                        color: sel ? t.color : esNuevo ? '#fff' : 'var(--color-text-muted)',
                      }}
                    >
                      {t.total_productos}
                    </span>
                  </button>
                );
              })}
              {tagsOcultas > 0 && (
                <button
                  onClick={() => setTagsExpandidas((v) => !v)}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px',
                    padding: '7px 12px',
                    borderRadius: '20px',
                    border: '1px dashed var(--color-secondary)',
                    background: 'var(--color-surface)',
                    color: 'var(--color-secondary)',
                    fontSize: '12px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    whiteSpace: 'nowrap',
                    flexShrink: 0,
                  }}
                >
                  {tagsExpandidas ? (
                    <>
                      Ver menos <FiX size={12} />
                    </>
                  ) : (
                    <>
                      +{tagsOcultas} más <FiChevronDown size={12} />
                    </>
                  )}
                </button>
              )}
            </div>
            );
          })()}

          {(combos.length > 0 || tags.filter((t) => t.prioridad).length > 0) && (
            <div style={{ display: 'flex', gap: '8px', marginBottom: '10px' }}>
              {combos.length > 0 && (
                <button
                  onClick={() => {
                    setSoloCombos((v) => !v);
                    if (!soloCombos) {
                      setDepSeleccionado(null);
                      seleccionarCategoria(categoriaSeleccionada);
                    }
                  }}
                  style={{
                    flex: 1,
                    minWidth: 0,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                    padding: '8px 10px',
                    borderRadius: '20px',
                    border: soloCombos ? '1.5px solid #c5221f' : '1px solid var(--color-border)',
                    background: soloCombos
                      ? 'linear-gradient(135deg, #c5221f 0%, #ea4335 100%)'
                      : 'var(--color-surface)',
                    color: soloCombos ? '#fff' : '#c5221f',
                    fontSize: '12px',
                    fontWeight: 700,
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    boxShadow: soloCombos ? '0 3px 10px rgba(197,34,31,0.3)' : 'none',
                    transition: 'all 0.15s ease',
                  }}
                >
                  <FiZap size={13} style={{ flexShrink: 0 }} />
                  <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    Promociones
                  </span>
                  <span
                    style={{
                      fontSize: '10px',
                      fontWeight: 700,
                      padding: '1px 6px',
                      borderRadius: '10px',
                      background: soloCombos ? 'rgba(255,255,255,0.25)' : '#c5221f18',
                      flexShrink: 0,
                    }}
                  >
                    {combos.length}
                  </span>
                </button>
              )}
              {tags
                .filter((t) => t.prioridad)
                .slice(0, 2)
                .map((t) => {
                  const sel = tagSeleccionado === t.id;
                  return (
                    <button
                      key={`prioridad-${t.id}`}
                      onClick={() => seleccionarTag(t.id)}
                      style={{
                        flex: 1,
                        minWidth: 0,
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        padding: '8px 10px',
                        borderRadius: '20px',
                        border: sel ? `1.5px solid ${t.color}` : '1px solid var(--color-border)',
                        background: sel ? `${t.color}16` : 'var(--color-surface)',
                        color: sel ? t.color : 'var(--color-text)',
                        fontSize: '12px',
                        fontWeight: 700,
                        cursor: 'pointer',
                        fontFamily: 'inherit',
                        boxShadow: sel ? `0 2px 8px ${t.color}30` : 'none',
                        transition: 'all 0.15s ease',
                      }}
                    >
                      <FiStar size={12} color={sel ? t.color : '#f0b400'} style={{ flexShrink: 0 }} />
                      {t.icono && <span style={{ fontSize: '14px', flexShrink: 0 }}>{t.icono}</span>}
                      <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {t.nombre}
                      </span>
                    </button>
                  );
                })}
              {soloCombos && (
                <button
                  onClick={() => setSoloCombos(false)}
                  style={{
                    flexShrink: 0,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px',
                    padding: '7px 12px',
                    borderRadius: '20px',
                    border: 'none',
                    background: 'transparent',
                    color: 'var(--color-text-secondary)',
                    fontSize: '12px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                    textDecoration: 'underline',
                  }}
                >
                  Ver todo <FiX size={12} />
                </button>
              )}
            </div>
          )}

          {sede && (
            <div
              style={{
                ...S.sedeInfo,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div>
                <span style={{ fontSize: '11px', color: 'var(--color-text-secondary)' }}>
                  <FiMapPin size={11} style={{ marginRight: 4, verticalAlign: 'middle' }} />
                  Entregando en:
                </span>
                <span
                  style={{
                    fontSize: '12px',
                    fontWeight: 600,
                    color: 'var(--color-primary)',
                    marginLeft: 6,
                  }}
                >
                  {direccionTexto && direccionTexto !== 'Ubicación seleccionada'
                    ? direccionTexto
                    : sede?.nombre || 'Tu ubicación'}
                </span>
              </div>
              {config?.requiere_ubicacion_cliente !== false && (
                <button
                  onClick={abrirCambiarDireccion}
                  style={{
                    padding: '4px 10px',
                    borderRadius: 8,
                    border: '1px solid var(--color-border)',
                    backgroundColor: 'transparent',
                    color: 'var(--color-text-secondary)',
                    fontSize: 11,
                    fontWeight: 600,
                    cursor: 'pointer',
                    fontFamily: 'inherit',
                  }}
                >
                  <FiMapPin size={12} style={{ marginRight: 4, verticalAlign: 'middle' }} />
                  Cambiar
                </button>
              )}
            </div>
          )}

          {bloqueado && pedidoEnEdicion && (
            <div
              style={{
                padding: '10px 16px',
                backgroundColor: 'var(--color-bg-hover)',
                margin: '0 0 8px',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                fontSize: '12px',
              }}
            >
              <FiPackage size={16} color="var(--color-secondary)" />
              <div style={{ flex: 1, color: 'var(--color-text-secondary)' }}>
                Tu pedido esta en{' '}
                <strong>{pedidoEnEdicion.estado}</strong>. No puedes modificar productos.
              </div>
            </div>
          )}
          {!bloqueado && pedidoEnEdicion && pedidoEnEdicion.estado === 'en_revision' && config?.cliente_puede_modificar_en_revision && (
            <div
              style={{
                padding: '8px 16px',
                backgroundColor: '#f0fdf4',
                margin: '0 0 8px',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                fontSize: '12px',
              }}
            >
              <FiCheckCircle size={16} color="var(--color-success)" />
              <div style={{ flex: 1, color: 'var(--color-text-secondary)' }}>
                Puedes modificar tu pedido. Los cambios se notificaran al asesor.
              </div>
            </div>
          )}

          {isMobile && (
            <div style={{ padding: '0 8px', marginBottom: '8px' }}>
              <button
                onClick={() => setShowMobileDeptos(true)}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '12px 14px',
                  borderRadius: '12px',
                  border: '1px solid var(--color-border)',
                  backgroundColor: 'var(--color-surface)',
                  color: 'var(--color-text)',
                  fontSize: '14px',
                  fontFamily: 'inherit',
                  cursor: 'pointer',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                }}
              >
                <FiFolder size={18} color="var(--color-secondary)" />
                <span style={{ flex: 1, textAlign: 'left', fontWeight: 500 }}>
                  {depSeleccionado
                    ? departamentos.find((d) => d.codigo === depSeleccionado)?.nombre || 'Filtrar'
                    : 'Filtrar productos'}
                </span>
                <FiChevronDown size={16} color="var(--color-text-secondary)" />
              </button>
            </div>
          )}

          {esCorporativo && puedeCargarOrdenCompra && (
            <div style={{ padding: '0 8px', marginBottom: '8px' }}>
              <button
                onClick={() => setVerCargarOrdenCompra(true)}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  padding: '12px 14px',
                  borderRadius: '12px',
                  border: '1.5px dashed var(--color-secondary)',
                  backgroundColor: 'var(--color-surface)',
                  color: 'var(--color-secondary)',
                  fontSize: '14px',
                  fontWeight: 700,
                  fontFamily: 'inherit',
                  cursor: 'pointer',
                }}
              >
                <FiFileText size={18} />
                <span style={{ flex: 1, textAlign: 'left' }}>Cargar orden de compra</span>
              </button>
            </div>
          )}

          {(depSeleccionado || categoriaSeleccionada || tagSeleccionado || marcaSeleccionada) && (
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px', padding: isMobile ? '0 8px 8px' : '0 16px 12px' }}>
              {depSeleccionado && (
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '5px 12px',
                    borderRadius: '18px',
                    background: 'var(--color-secondary)',
                    color: 'var(--color-surface)',
                    fontSize: '12px',
                    fontWeight: 600,
                  }}
                >
                  <FiFolder size={12} />
                  {departamentos.find((d) => d.codigo === depSeleccionado)?.nombre}
                  <button
                    onClick={() => setDepSeleccionado(null)}
                    style={{
                      border: 'none',
                      background: 'rgba(255,255,255,0.2)',
                      borderRadius: '50%',
                      width: '16px',
                      height: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      color: 'var(--color-surface)',
                      padding: 0,
                    }}
                  >
                    <FiX size={11} />
                  </button>
                </span>
              )}
              {categoriaSeleccionada && (
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '5px 12px',
                    borderRadius: '18px',
                    background: 'var(--color-primary)',
                    color: 'var(--color-surface)',
                    fontSize: '12px',
                    fontWeight: 600,
                  }}
                >
                  <CarIcon size={12} color="var(--color-surface)" />
                  {categoriaSeleccionada}
                  <button
                    onClick={() => seleccionarCategoria(categoriaSeleccionada)}
                    style={{
                      border: 'none',
                      background: 'rgba(255,255,255,0.2)',
                      borderRadius: '50%',
                      width: '16px',
                      height: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      color: 'var(--color-surface)',
                      padding: 0,
                    }}
                  >
                    <FiX size={11} />
                  </button>
                </span>
              )}
              {tagSeleccionado && (() => {
                const t = tags.find((x) => x.id === tagSeleccionado);
                return (
                  <span
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '6px',
                      padding: '5px 12px',
                      borderRadius: '18px',
                      background: t?.color || 'var(--color-primary)',
                      color: '#fff',
                      fontSize: '12px',
                      fontWeight: 600,
                    }}
                  >
                    {t?.icono && <span>{t.icono}</span>}
                    {t?.nombre || 'Etiqueta'}
                    <button
                      onClick={() => seleccionarTag(tagSeleccionado)}
                      style={{
                        border: 'none',
                        background: 'rgba(255,255,255,0.2)',
                        borderRadius: '50%',
                        width: '16px',
                        height: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        color: '#fff',
                        padding: 0,
                      }}
                    >
                      <FiX size={11} />
                    </button>
                  </span>
                );
              })()}
              {marcaSeleccionada && (
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '6px',
                    padding: '5px 12px',
                    borderRadius: '18px',
                    background: '#0d8043',
                    color: '#fff',
                    fontSize: '12px',
                    fontWeight: 600,
                  }}
                >
                  <FiTag size={12} />
                  {marcaSeleccionada}
                  <button
                    onClick={() => seleccionarMarca(marcaSeleccionada)}
                    style={{
                      border: 'none',
                      background: 'rgba(255,255,255,0.2)',
                      borderRadius: '50%',
                      width: '16px',
                      height: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      color: '#fff',
                      padding: 0,
                    }}
                  >
                    <FiX size={11} />
                  </button>
                </span>
              )}
              <button
                onClick={() => {
                  setDepSeleccionado(null);
                  seleccionarCategoria(categoriaSeleccionada);
                  seleccionarTag(tagSeleccionado);
                  seleccionarMarca(marcaSeleccionada);
                }}
                style={{
                  border: 'none',
                  background: 'transparent',
                  color: 'var(--color-text-secondary)',
                  fontSize: '12px',
                  fontWeight: 500,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  textDecoration: 'underline',
                }}
              >
                Limpiar
              </button>
            </div>
          )}
          </div>
        </div>

        {/* Grid */}
        <main ref={gridRef} style={S.grid} data-tutorial="catalogo-grid">
          {combosFiltrados.length > 0 &&
            (soloCombos || (!depSeleccionado && !categoriaSeleccionada && !tagSeleccionado && !marcaSeleccionada)) && (
              <div style={{ marginBottom: '16px' }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '12px',
                  }}
                >
                  <div
                    style={{
                      width: '28px',
                      height: '28px',
                      borderRadius: '8px',
                      background: 'linear-gradient(135deg, #c5221f 0%, #ea4335 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <FiZap size={15} color="#fff" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <span style={{ fontSize: '16px', fontWeight: 800, color: 'var(--color-primary)' }}>
                      Promociones
                    </span>
                    {busquedaInput && (
                      <span style={{ fontSize: '12px', color: 'var(--color-text-secondary)', marginLeft: '8px' }}>
                        que coinciden con "{busquedaInput.trim()}"
                      </span>
                    )}
                  </div>
                  <span
                    style={{
                      fontSize: '11px',
                      fontWeight: 700,
                      color: '#c5221f',
                      background: '#fde7e7',
                      padding: '3px 10px',
                      borderRadius: '20px',
                    }}
                  >
                    {combosFiltrados.length} {combosFiltrados.length === 1 ? 'combo' : 'combos'}
                  </span>
                </div>
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
                    gap: '14px',
                  }}
                >
                  {combosFiltrados.map((combo) => {
                    const comboTumb = combo.thumb_url || combo.imagen_url;
                    const comboImgSrc = getImagenUrl(comboTumb);
                    const rota = comboImgRota[combo.id];
                    const pct =
                      combo.precio_sin_descuento > 0
                        ? Math.max(0, Math.round((combo.ahorro / combo.precio_sin_descuento) * 100))
                        : 0;
                    return (
                      <div
                        key={combo.id}
                        onClick={() => abrirComboDetalle(combo)}
                        style={{
                          backgroundColor: 'var(--color-surface)',
                          borderRadius: '18px',
                          border: '1.5px solid #fbe0e0',
                          overflow: 'hidden',
                          cursor: 'pointer',
                          display: 'flex',
                          flexDirection: 'column',
                          position: 'relative',
                          fontFamily: 'inherit',
                          width: '100%',
                          boxShadow: '0 2px 6px rgba(197,34,31,0.06)',
                          transition: 'box-shadow 0.15s, transform 0.15s, border-color 0.15s',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.boxShadow = '0 10px 24px rgba(197,34,31,0.16)';
                          e.currentTarget.style.transform = 'translateY(-3px)';
                          e.currentTarget.style.borderColor = '#c5221f';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.boxShadow = '0 2px 6px rgba(197,34,31,0.06)';
                          e.currentTarget.style.transform = 'none';
                          e.currentTarget.style.borderColor = '#fbe0e0';
                        }}
                      >
                        <div
                          style={{
                            width: '100%',
                            height: '120px',
                            background:
                              'linear-gradient(135deg, var(--color-bg-hover) 0%, #fde7e7 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            position: 'relative',
                            flexShrink: 0,
                          }}
                        >
                          {comboImgSrc && !rota ? (
                            <img
                              src={comboImgSrc}
                              alt={combo.nombre}
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              onError={() => setComboImgRota((p) => ({ ...p, [combo.id]: true }))}
                            />
                          ) : (
                            <FiTag size={36} color="#c5221f" />
                          )}
                          <span
                            style={{
                              position: 'absolute',
                              top: 8,
                              left: 8,
                              fontSize: '9px',
                              fontWeight: 800,
                              letterSpacing: '0.6px',
                              color: '#fff',
                              background: 'linear-gradient(135deg, #c5221f 0%, #ea4335 100%)',
                              padding: '3px 8px',
                              borderRadius: '6px',
                              textTransform: 'uppercase',
                            }}
                          >
                            Promoción
                          </span>
                          {pct > 0 && (
                            <span
                              style={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                fontSize: '11px',
                                fontWeight: 800,
                                color: '#137333',
                                background: '#e6f4ea',
                                padding: '3px 8px',
                                borderRadius: '20px',
                              }}
                            >
                              -{pct}%
                            </span>
                          )}
                        </div>
                        <div
                          style={{
                            padding: '12px 12px 14px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '5px',
                            flex: 1,
                            textAlign: 'left',
                          }}
                        >
                          <div
                            style={{
                              fontSize: '13px',
                              fontWeight: 800,
                              color: 'var(--color-primary)',
                              lineHeight: 1.3,
                              wordBreak: 'break-word',
                            }}
                          >
                            {combo.nombre}
                          </div>
                          <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', flexWrap: 'wrap' }}>
                            {enRevision || combo.precio_oculto ? (
                              <span style={{ fontSize: '13px', fontWeight: 700, color: 'var(--color-text-muted)' }}>
                                Precio oculto hasta tu aprobación
                              </span>
                            ) : (
                              <>
                                <span style={{ fontSize: '17px', fontWeight: 800, color: '#c5221f' }}>
                                  ${fmtMonto(combo.precio || 0)}
                                </span>
                                {config?.mostrar_precio_bs !== false &&
                                  Number.isFinite(tasaCambio) &&
                                  tasaCambio > 0 && (
                                    <span style={{ fontSize: '11px', color: 'var(--color-text-secondary)' }}>
                                      Bs {fmtMonto((combo.precio || 0) * tasaCambio)}
                                    </span>
                                  )}
                                {combo.precio_sin_descuento > 0 &&
                                  combo.precio_sin_descuento > combo.precio && (
                                    <span
                                      style={{
                                        fontSize: '11px',
                                        color: 'var(--color-text-secondary)',
                                        textDecoration: 'line-through',
                                      }}
                                    >
                                      ${fmtMonto(combo.precio_sin_descuento || 0)}
                                    </span>
                                  )}
                              </>
                            )}
                          </div>
                          {combo.items.length > 0 && (
                            <div
                              style={{
                                fontSize: '10px',
                                color: 'var(--color-text-secondary)',
                                lineHeight: 1.45,
                                display: '-webkit-box',
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                wordBreak: 'break-word',
                              }}
                            >
                              <span style={{ fontWeight: 700, color: 'var(--color-text-muted)' }}>Incluye: </span>
                              {combo.items.map((it) => `${it.cantidad}× ${it.nombre}`).join(' · ')}
                            </div>
                          )}
                          {combo.ahorro > 0 && (
                            <div
                              style={{
                                fontSize: '10px',
                                fontWeight: 700,
                                color: '#137333',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                marginTop: 'auto',
                              }}
                            >
                              <FiCheckCircle size={12} />
                              Ahorras ${fmtMonto(combo.ahorro)}
                            </div>
                          )}
                          <span
                            style={{
                              marginTop: '8px',
                              width: '100%',
                              padding: '9px 0',
                              borderRadius: '10px',
                              background: 'linear-gradient(135deg, #c5221f 0%, #ea4335 100%)',
                              color: '#fff',
                              fontSize: '12px',
                              fontWeight: 700,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px',
                              boxShadow: '0 3px 8px rgba(197,34,31,0.25)',
                            }}
                          >
                            <FiPlus size={13} /> Ver
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
                {ofertasFiltradas.length > 0 && (
                  <div style={{ marginTop: '18px' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: '12px',
                      }}
                    >
                      <FiZap size={14} color="#c5221f" />
                      <span style={{ fontSize: '14px', fontWeight: 800, color: 'var(--color-primary)' }}>
                        Productos en oferta
                      </span>
                      <span
                        style={{
                          fontSize: '11px',
                          fontWeight: 700,
                          color: '#c5221f',
                          background: '#fde7e7',
                          padding: '3px 10px',
                          borderRadius: '20px',
                        }}
                      >
                        {ofertasFiltradas.length}
                      </span>
                    </div>
                    <div
                      style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
                        gap: '14px',
                      }}
                    >
                      {ofertasFiltradas.map((prod) => {
                        const imagenes = prod.imagenes || [];
                        const mediaPrincipal = imagenes.length > 0 ? imagenes[0] : null;
                        const currentUrl = mediaPrincipal
                          ? mediaPrincipal.url
                          : prod.thumb_url || prod.imagen_url;
                        const pva2 = config?.permitir_venta_agotados;
                        const stockOk = prod.stock > 0;
                        const interactivo = pva2 || stockOk;
                        return (
                          <button
                            key={prod.codigo}
                            onClick={() => interactivo && abrirDetalle(prod.codigo)}
                            disabled={!interactivo}
                            style={{
                              ...S.productCard,
                              opacity: interactivo ? 1 : 0.5,
                              cursor: interactivo ? 'pointer' : 'default',
                              borderColor: '#fbe0e0',
                            }}
                          >
                            {prod.en_promocion && (
                              <span
                                style={{
                                  position: 'absolute',
                                  top: '-6px',
                                  left: '8px',
                                  zIndex: 2,
                                  background: 'linear-gradient(135deg, #c5221f 0%, #ea4335 100%)',
                                  color: '#fff',
                                  fontSize: '9px',
                                  fontWeight: 800,
                                  letterSpacing: '0.4px',
                                  padding: '3px 8px',
                                  borderRadius: '8px',
                                  boxShadow: '0 2px 6px rgba(197,34,31,0.35)',
                                }}
                              >
                                OFERTA -{prod.porcentaje_descuento}%
                              </span>
                            )}
                            <div style={S.productImage}>
                              {getImagenUrl(currentUrl) ? (
                                <img
                                  src={getImagenUrl(currentUrl)}
                                  alt={prod.descripcion}
                                  style={S.productImg}
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                  }}
                                />
                              ) : (
                                <FiPackage size={28} color="var(--color-secondary)" />
                              )}
                              {(prod.tags || []).length > 0 && (
                                <div
                                  style={{
                                    position: 'absolute',
                                    top: '6px',
                                    left: '6px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '3px',
                                    alignItems: 'flex-start',
                                  }}
                                >
                                  {(prod.tags || []).map((t) => (
                                    <span
                                      key={t.id}
                                      style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '3px',
                                        fontSize: '8px',
                                        fontWeight: 700,
                                        padding: '2px 6px',
                                        borderRadius: '6px',
                                        background: t.color || '#0B1A4A',
                                        color: '#fff',
                                        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
                                      }}
                                    >
                                      {t.icono && <span>{t.icono}</span>}
                                      {t.nombre}
                                    </span>
                                  ))}
                                </div>
                              )}
                            </div>
                            <div style={S.productInfo}>
                              <div style={S.productName}>{prod.descripcion}</div>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                <div style={S.productPrice}>${fmtMonto(prod.precio || 0)}</div>
                                {prod.porcentaje_descuento != null && (
                                  <span
                                    style={{
                                      background: '#c5221f',
                                      color: '#fff',
                                      fontSize: '11px',
                                      fontWeight: 700,
                                      padding: '1px 7px',
                                      borderRadius: '10px',
                                    }}
                                  >
                                    -{prod.porcentaje_descuento}%
                                  </span>
                                )}
                              </div>
                              {prod.precio_original != null && (
                                <div
                                  style={{
                                    fontSize: '12px',
                                    color: 'var(--color-text-muted)',
                                    textDecoration: 'line-through',
                                  }}
                                >
                                  ${fmtMonto(prod.precio_original || 0)}
                                </div>
                              )}
                            </div>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}

          {soloCombos && combosFiltrados.length === 0 && ofertasFiltradas.length === 0 && (
            <div style={S.emptyState}>
              <FiTag size={48} color="var(--color-text-muted)" />
              <span
                style={{
                  color: 'var(--color-text-secondary)',
                  fontSize: '14px',
                  marginTop: '12px',
                }}
              >
                {busquedaInput
                  ? `No hay promociones que coincidan con "${busquedaInput.trim()}"`
                  : 'No hay promociones disponibles'}
              </span>
            </div>
          )}

          {!soloCombos &&
            (cargandoProductos ? (
              <div style={S.loadingState}>
                <div style={S.spinner} />
                <span style={{ color: 'var(--color-text-secondary)', fontSize: '14px' }}>
                  Cargando productos...
                </span>
              </div>
            ) : productos.length === 0 ? (
              <div style={S.emptyState}>
                <FiPackage size={48} color="var(--color-text-muted)" />
                <span
                  style={{
                    color: 'var(--color-text-secondary)',
                    fontSize: '14px',
                    marginTop: '12px',
                  }}
                >
                  No se encontraron productos
                </span>
              </div>
            ) : (
              <>
              {modoVista === 'grid' ? (
                <div style={S.productGrid}>
                  {productosOrdenados.map((prod) => {
                    const imagenes = prod.imagenes || [];
                    const mediaPrincipal = imagenes.length > 0 ? imagenes[0] : null;
                    const mediaHover = imagenes.length > 1 ? imagenes[1] : null;
                    const isHovered = hoveredCodigo === prod.codigo;
                    const currentMedia = isHovered && mediaHover ? mediaHover : mediaPrincipal;
                    const currentUrl = currentMedia
                      ? currentMedia.url
                      : prod.thumb_url || prod.imagen_url;
                    const isVideo = currentMedia?.tipo === 'video';
                    const pva = config?.permitir_venta_agotados;
                    const stockOk = prod.stock > 0;
                    const interactivo = pva || stockOk;
                    return (
                      <button
                        key={prod.codigo}
                        onClick={() => interactivo && abrirDetalle(prod.codigo)}
                        disabled={!interactivo}
                        onMouseEnter={() => setHoveredCodigo(prod.codigo)}
                        onMouseLeave={() => setHoveredCodigo(null)}
                        style={{
                          ...S.productCard,
                          opacity: interactivo ? 1 : 0.5,
                          cursor: interactivo ? 'pointer' : 'default',
                          borderColor: isHovered && interactivo ? 'var(--color-secondary)' : '#F0F0F0',
                          boxShadow: isHovered && interactivo ? '0 8px 24px rgba(11,26,74,0.12)' : 'none',
                          transform: isHovered && interactivo ? 'translateY(-3px)' : 'none',
                        }}
                      >
                        {prod.en_promocion && (
                          <span
                            style={{
                              position: 'absolute',
                              top: '-6px',
                              left: '8px',
                              zIndex: 2,
                              background: 'linear-gradient(135deg, #c5221f 0%, #ea4335 100%)',
                              color: '#fff',
                              fontSize: '9px',
                              fontWeight: 800,
                              letterSpacing: '0.4px',
                              padding: '3px 8px',
                              borderRadius: '8px',
                              boxShadow: '0 2px 6px rgba(197,34,31,0.35)',
                            }}
                          >
                            OFERTA -{prod.porcentaje_descuento}%
                          </span>
                        )}
                        <div style={S.productImage}>
                          {isVideo ? (
                            <video
                              src={getImagenUrl(currentUrl)}
                              autoPlay
                              muted
                              loop
                              playsInline
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : getImagenUrl(currentUrl) ? (
                            <img
                              src={getImagenUrl(currentUrl)}
                              alt={prod.descripcion}
                              style={S.productImg}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          ) : (
                            <FiPackage size={28} color="var(--color-secondary)" />
                          )}
                          {(prod.tags || []).length > 0 && (
                            <div
                              style={{
                                position: 'absolute',
                                top: '6px',
                                left: '6px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '3px',
                                alignItems: 'flex-start',
                              }}
                            >
                              {(prod.tags || []).map((t) => (
                                <span
                                  key={t.id}
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '3px',
                                    fontSize: '8px',
                                    fontWeight: 700,
                                    padding: '2px 6px',
                                    borderRadius: '6px',
                                    background: t.color || '#0B1A4A',
                                    color: '#fff',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
                                  }}
                                >
                                  {t.icono && <span>{t.icono}</span>}
                                  {t.nombre}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                        <div style={S.productInfo}>
                          <div style={S.productName}>{prod.descripcion}</div>
                          {prod.descripcion_larga && (
                            <div style={S.productDesc}>{prod.descripcion_larga}</div>
                          )}
                          {enRevision || prod.precio_oculto ? (
                            <div style={S.productPriceOculto}>Precio oculto</div>
                          ) : (
                            <>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                <div style={S.productPrice}>${fmtMonto(prod.precio || 0)}</div>
                                {prod.en_promocion && prod.porcentaje_descuento != null && (
                                  <span
                                    style={{
                                      background: '#c5221f',
                                      color: '#fff',
                                      fontSize: '11px',
                                      fontWeight: 700,
                                      padding: '1px 7px',
                                      borderRadius: '10px',
                                    }}
                                  >
                                    -{prod.porcentaje_descuento}%
                                  </span>
                                )}
                              </div>
                              {prod.en_promocion && prod.precio_original != null && (
                                <div
                                  style={{
                                    fontSize: '12px',
                                    color: 'var(--color-text-muted)',
                                    textDecoration: 'line-through',
                                  }}
                                >
                                  ${fmtMonto(prod.precio_original || 0)}
                                </div>
                              )}
                              {config?.mostrar_precio_bs !== false && Number.isFinite(tasaCambio) && tasaCambio > 0 && (
                                <div style={S.productPriceBs}>
                                  Bs {fmtMonto((prod.precio || 0) * tasaCambio)}
                                </div>
                              )}
                            </>
                          )}

                          {!pva && !enRevision && !prod.precio_oculto && (
                          <div
                            style={{
                              ...S.stockBadge,
                              color:
                                prod.tipo_producto === 'servicio'
                                  ? '#5f6368'
                                  : prod.stock > 20
                                    ? '#0d904f'
                                    : prod.stock > 0
                                      ? '#ea8600'
                                      : 'var(--color-danger)',
                            }}
                          >
                            {prod.tipo_producto === 'servicio'
                              ? 'Servicio'
                              : prod.stock > 20
                                ? 'Disponible'
                                : prod.stock > 0
                                  ? `Quedan ${prod.stock}`
                                  : 'Agotado'}
                          </div>
                          )}
                          {prod.referencia && (
                            <div
                              style={{
                                fontSize: '10px',
                                color: 'var(--color-text-muted)',
                                marginTop: '2px',
                              }}
                            >
                              Ref: {prod.referencia}
                            </div>
                          )}
                        </div>
                        {prod.pesable && <span style={S.pesableTag}>Pesable</span>}
                      </button>
                    );
                  })}
                </div>
              ) : (
                <div style={S.productList}>
                  {productosOrdenados.map((prod) => {
                    const imagenes = prod.imagenes || [];
                    const mediaPrincipal = imagenes.length > 0 ? imagenes[0] : null;
                    const currentUrl = mediaPrincipal
                      ? mediaPrincipal.url
                      : prod.thumb_url || prod.imagen_url;
                    const isVideo = mediaPrincipal?.tipo === 'video';
                    const pva = config?.permitir_venta_agotados;
                    const stockOk = prod.stock > 0;
                    const interactivo = pva || stockOk;
                    return (
                      <button
                        key={prod.codigo}
                        onClick={() => interactivo && abrirDetalle(prod.codigo)}
                        disabled={!interactivo}
                        style={{
                          ...S.productListItem,
                          opacity: interactivo ? 1 : 0.5,
                          cursor: interactivo ? 'pointer' : 'default',
                        }}
                      >
                        <div style={S.productListImg}>
                          {isVideo ? (
                            <video
                              src={getImagenUrl(currentUrl)}
                              autoPlay
                              muted
                              loop
                              playsInline
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />
                          ) : getImagenUrl(currentUrl) ? (
                            <img
                              src={getImagenUrl(currentUrl)}
                              alt={prod.descripcion}
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          ) : (
                            <FiPackage size={24} color="var(--color-secondary)" />
                          )}
                          {prod.en_promocion && (
                            <span
                              style={{
                                position: 'absolute',
                                top: '2px',
                                left: '2px',
                                fontSize: '7px',
                                fontWeight: 700,
                                background: 'linear-gradient(135deg, #c5221f 0%, #ea4335 100%)',
                                color: '#fff',
                                padding: '2px 5px',
                                borderRadius: '5px',
                              }}
                            >
                              -{prod.porcentaje_descuento}%
                            </span>
                          )}
                          {prod.pesable && (
                            <span
                              style={{
                                position: 'absolute',
                                top: '2px',
                                right: '2px',
                                fontSize: '7px',
                                fontWeight: 600,
                                backgroundColor: '#fef7e0',
                                color: '#b06000',
                                padding: '1px 4px',
                                borderRadius: '4px',
                              }}
                            >
                              Pesable
                            </span>
                          )}
                          {(prod.tags || []).length > 0 && (
                            <div
                              style={{
                                position: 'absolute',
                                bottom: '2px',
                                left: '2px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '2px',
                                alignItems: 'flex-start',
                              }}
                            >
                              {(prod.tags || []).map((t) => (
                                <span
                                  key={t.id}
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '2px',
                                    fontSize: '7px',
                                    fontWeight: 700,
                                    padding: '1px 5px',
                                    borderRadius: '4px',
                                    background: t.color || '#0B1A4A',
                                    color: '#fff',
                                  }}
                                >
                                  {t.icono && <span>{t.icono}</span>}
                                  {t.nombre}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                        <div style={S.productListInfo}>
                          <div style={S.productListName}>{prod.descripcion}</div>
                          {prod.descripcion_larga && (
                            <div style={S.productListDesc}>{prod.descripcion_larga}</div>
                          )}
                        </div>
                        <div style={S.productListActions}>
                          {enRevision || prod.precio_oculto ? (
                            <div style={S.productListPriceOculto}>Precio oculto</div>
                          ) : (
                            <>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                <div style={S.productListPrice}>${fmtMonto(prod.precio || 0)}</div>
                                {prod.en_promocion && prod.porcentaje_descuento != null && (
                                  <span
                                    style={{
                                      background: '#c5221f',
                                      color: '#fff',
                                      fontSize: '11px',
                                      fontWeight: 700,
                                      padding: '1px 7px',
                                      borderRadius: '10px',
                                    }}
                                  >
                                    -{prod.porcentaje_descuento}%
                                  </span>
                                )}
                              </div>
                              {prod.en_promocion && prod.precio_original != null && (
                                <div
                                  style={{
                                    fontSize: '12px',
                                    color: 'var(--color-text-muted)',
                                    textDecoration: 'line-through',
                                  }}
                                >
                                  ${fmtMonto(prod.precio_original || 0)}
                                </div>
                              )}
                              {config?.mostrar_precio_bs !== false && Number.isFinite(tasaCambio) && tasaCambio > 0 && (
                                <div style={S.productListPriceBs}>
                                  Bs {fmtMonto((prod.precio || 0) * tasaCambio)}
                                </div>
                              )}
                            </>
                          )}
                          {!pva && !enRevision && !prod.precio_oculto && (
                            <div
                              style={{
                                ...S.productListStock,
                                color:
                                  prod.tipo_producto === 'servicio'
                                    ? '#5f6368'
                                    : prod.stock > 20
                                      ? '#0d904f'
                                      : prod.stock > 0
                                        ? '#ea8600'
                                        : 'var(--color-danger)',
                              }}
                            >
                              {prod.tipo_producto === 'servicio'
                                ? 'Servicio'
                                : prod.stock > 20
                                  ? 'Disponible'
                                  : prod.stock > 0
                                    ? `Quedan ${prod.stock}`
                                    : 'Agotado'}
                            </div>
                          )}
                        </div>
                      </button>
                    );
                  })}
                </div>
              )}
              {cargandoMas && (
                <div style={{ textAlign: 'center', padding: '16px' }}>
                  <div style={S.spinnerSmall} />
                </div>
              )}
              {hasMore && !cargandoMas && (
                <div ref={sentinelRef} style={{ height: '1px' }} />
              )}
            </>
            ))}
        </main>

        {/* Carrito flotante - solo movil */}
        {carrito.length > 0 && isMobile && (
          <div
            style={S.cartFloat}
            onClick={() => setProductoDetalle({ _carrito: true })}
            data-tutorial="carrito-fab"
          >
            <FiShoppingCart size={20} color="#fff" />
            <span style={S.cartCount}>{carrito.length}</span>
            <span style={S.cartTotal}>${fmtMonto(totalCarrito)}</span>
          </div>
        )}

        {/* Carrito corporativo distribuido */}
        {esCorporativo && corporativo.contarItems > 0 && (
          <div
            style={{
              position: 'fixed',
              left: isMobile ? '16px' : '50%',
              right: isMobile ? '16px' : undefined,
              transform: isMobile ? undefined : 'translateX(-50%)',
              bottom: '16px',
              maxWidth: isMobile ? undefined : '520px',
              width: isMobile ? undefined : 'calc(100% - 32px)',
              backgroundColor: 'var(--color-primary)',
              color: '#fff',
              borderRadius: '16px',
              padding: '12px 16px',
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              boxShadow: '0 8px 24px rgba(0,0,0,0.18)',
              zIndex: 90,
            }}
          >
            <button
              onClick={() => setVerCarritoCorp(true)}
              style={{
                flex: 1,
                minWidth: 0,
                border: 'none',
                background: 'transparent',
                color: '#fff',
                textAlign: 'left',
                cursor: 'pointer',
                fontFamily: 'inherit',
                padding: 0,
              }}
            >
              <div style={{ fontSize: '12px', opacity: 0.85 }}>Pedido corporativo · {corporativo.contarItems} items</div>
              <div style={{ fontSize: '16px', fontWeight: 700 }}>${fmtMonto(corporativo.totalGeneral)}</div>
            </button>
            <button
              onClick={() => setVerCarritoCorp(true)}
              style={{
                border: 'none',
                borderRadius: '10px',
                padding: '10px 16px',
                backgroundColor: 'var(--color-secondary)',
                color: '#fff',
                fontSize: '13px',
                fontWeight: 700,
                cursor: 'pointer',
                fontFamily: 'inherit',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
              }}
            >
              <FiShoppingCart size={16} /> Ver
            </button>
          </div>
        )}

        {/* Carrito corporativo - sheet agrupado por sucursal */}
        {verCarritoCorp && (
          <div style={S.detailOverlay} onClick={() => setVerCarritoCorp(false)}>
            <div
              style={{ ...S.detailModal, maxHeight: isMobile ? '90vh' : '80vh' }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <h3 style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: 'var(--color-primary)' }}>
                  Tu pedido corporativo
                </h3>
                <button onClick={() => setVerCarritoCorp(false)} style={S.detailClose}>
                  <FiX size={22} />
                </button>
              </div>

              {corporativo.contarItems === 0 ? (
                <p style={{ color: 'var(--color-text-secondary)', textAlign: 'center', padding: '20px' }}>
                  Tu carrito está vacío
                </p>
              ) : (
                <>
                  <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                    {sedesCorporativas.map((s) => {
                      const items = corporativo.cartCorp[s.id] || [];
                      if (items.length === 0) return null;
                      return (
                        <div key={s.id} style={{ marginBottom: '16px' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                            <div style={{ fontSize: '13px', fontWeight: 700, color: 'var(--color-secondary)' }}>
                              <FiMapPin size={13} style={{ marginRight: '4px', verticalAlign: '-2px' }} />
                              {s.nombre || ('Sucursal ' + s.id)}
                            </div>
                            <div style={{ fontSize: '13px', fontWeight: 700 }}>
                              ${fmtMonto(corporativo.totalPorSede(s.id))}
                            </div>
                          </div>
                          {s.direccion && (
                            <div style={{ fontSize: '11px', color: 'var(--color-text-secondary)', marginTop: '-4px', marginBottom: '6px' }}>
                              {s.direccion}
                            </div>
                          )}
                          {items.map((c, i) => {
                            const step = c.pesable ? 50 : 1;
                            const stockMax = c.pesable ? (c.stock || 0) * 1000 : (c.stock || 0);
                            const totalProd = Object.values(corporativo.cartCorp).reduce(
                              (acc, arr) => acc + (arr || []).filter((x) => x.codigo === c.codigo).reduce((a, x) => a + (x.cantidad || 0), 0),
                              0
                            );
                            const sinStock = !pva && !c.combo_id && totalProd + step > stockMax;
                            return (
                              <div key={i} style={S.cartItemRow}>
                                <div style={{ width: 40, height: 40, borderRadius: 8, flexShrink: 0, overflow: 'hidden', backgroundColor: 'var(--color-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                  {getImagenUrl(c.imagen_url) ? (
                                    <img src={getImagenUrl(c.imagen_url)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
                                  ) : (
                                    <FiPackage size={16} color="var(--color-text-muted)" />
                                  )}
                                </div>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <div style={{ fontSize: '13px', fontWeight: 600, color: 'var(--color-primary)' }}>{c.nombre}</div>
                                  <div style={{ fontSize: '12px', color: 'var(--color-text-secondary)', marginTop: '2px' }}>
                                    ${fmtMonto(c.precio || 0)}{config?.mostrar_precio_bs !== false ? ` / Bs ${fmtMonto(c.precio_bs || 0)}` : ''}
                                  </div>
                                  {c.pesable && <div style={{ fontSize: '10px', color: '#b06000' }}>Pesable - {(c.cantidad / 1000).toFixed(2)} kg</div>}
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                  <button
                                    onClick={() => corporativo.actualizarCantidadSede(s.id, i, -step)}
                                    disabled={c.cantidad <= step}
                                    style={{ ...S.cartCantBtn, opacity: c.cantidad <= step ? 0.3 : 1 }}
                                  >
                                    <FiMinus size={12} />
                                  </button>
                                  <span style={{ fontSize: '13px', fontWeight: 600, minWidth: '40px', textAlign: 'center' }}>
                                    {c.pesable ? (c.cantidad / 1000).toFixed(2) + ' kg' : c.cantidad}
                                  </span>
                                  <button
                                    onClick={() => corporativo.actualizarCantidadSede(s.id, i, step)}
                                    disabled={sinStock}
                                    style={{ ...S.cartCantBtn, opacity: sinStock ? 0.3 : 1 }}
                                  >
                                    <FiPlus size={12} />
                                  </button>
                                  <button
                                    onClick={() => corporativo.eliminarDeSede(s.id, i)}
                                    style={{ ...S.cartCantBtn, color: 'var(--color-danger)', borderColor: '#FFCDD2' }}
                                  >
                                    <FiX size={12} />
                                  </button>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      );
                    })}
                  </div>
                  <div style={{ borderTop: '1px solid var(--color-border)', padding: '12px 0 0', marginTop: '12px', display: 'flex', justifyContent: 'space-between', fontSize: '15px', fontWeight: 700 }}>
                    <span>Total</span>
                    <span style={{ color: 'var(--color-secondary)' }}>${fmtMonto(corporativo.totalGeneral)}</span>
                  </div>
                  <button
                    onClick={() => { setVerCarritoCorp(false); corporativo.confirmarPedido(); }}
                    disabled={corporativo.creandoPedido}
                    style={{ ...S.confirmarPedidoBtn, opacity: corporativo.creandoPedido ? 0.6 : 1 }}
                  >
                    <FiCheckCircle size={18} /> {corporativo.creandoPedido ? 'Guardando...' : 'Confirmar pedido'}
                  </button>
                </>
              )}
            </div>
          </div>
        )}

        {/* Detail Modal */}
        {productoDetalle && !productoDetalle._carrito && (
          <div
            style={{ ...S.detailOverlay, alignItems: isMobile ? 'flex-end' : 'center' }}
            onClick={cerrarDetalle}
          >
            <div
              style={{
                ...S.detailModal,
                borderRadius: isMobile ? '20px 20px 0 0' : '20px',
                maxWidth: isMobile ? '480px' : '520px',
                maxHeight: isMobile ? '90vh' : '85vh',
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <button onClick={cerrarDetalle} style={S.detailClose}>
                <FiX size={22} />
              </button>
              <button
                onClick={() => compartirProducto(productoDetalle)}
                title="Compartir por WhatsApp"
                aria-label="Compartir por WhatsApp"
                style={S.detailShare}
              >
                <FiShare2 size={20} />
              </button>

              {cargandoDetalle ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <div style={S.spinner} />
                </div>
              ) : (
                <>
                  <div style={S.detailImage}>
                    {productoDetalle.imagenes?.length > 0 &&
                      productoDetalle.imagenes[galIdx].tipo !== 'video' && (
                        <div
                          onClick={() =>
                            setVisorOpen({ images: productoDetalle.imagenes, startIdx: galIdx })
                          }
                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}
                        >
                          <img
                            src={getImagenUrl(productoDetalle.imagenes[galIdx].url)}
                            alt={productoDetalle.descripcion}
                            style={S.detailImg}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        </div>
                      )}
                    {productoDetalle.imagenes?.length > 0 &&
                      productoDetalle.imagenes[galIdx].tipo === 'video' && (
                        <video
                          key={productoDetalle.imagenes[galIdx].url}
                          src={getImagenUrl(productoDetalle.imagenes[galIdx].url)}
                          controls
                          playsInline
                          style={{
                            width: '100%',
                            minHeight: '200px',
                            background: '#000',
                            borderRadius: '12px',
                          }}
                        />
                      )}
                    {!productoDetalle.imagenes?.length &&
                      getImagenUrl(productoDetalle.imagen_url) && (
                        <div
                          onClick={() =>
                            setVisorOpen({
                              images: [{ url: productoDetalle.imagen_url }],
                              startIdx: 0,
                            })
                          }
                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}
                        >
                          <img
                            src={getImagenUrl(
                              productoDetalle.thumb_url || productoDetalle.imagen_url
                            )}
                            alt={productoDetalle.descripcion}
                            style={S.detailImg}
                            onError={(e) => {
                              e.target.style.display = 'none';
                            }}
                          />
                        </div>
                      )}
                    {!productoDetalle.imagenes?.length &&
                      !getImagenUrl(productoDetalle.imagen_url) && (
                        <FiPackage size={64} color="var(--color-secondary)" />
                      )}
                  </div>
                  {productoDetalle.imagenes?.length > 1 && (
                    <div
                      style={{
                        display: 'flex',
                        gap: '8px',
                        marginBottom: '16px',
                        overflowX: 'auto',
                        paddingBottom: '4px',
                      }}
                    >
                      {productoDetalle.imagenes.map((img, idx) => (
                        <button
                          key={idx}
                          onClick={() => setGalIdx(idx)}
                          style={{
                            width: '56px',
                            height: '56px',
                            borderRadius: '10px',
                            overflow: 'hidden',
                            flexShrink: 0,
                            border:
                              galIdx === idx
                                ? '2px solid var(--color-primary)'
                                : '2px solid transparent',
                            padding: 0,
                            cursor: 'pointer',
                            background: 'var(--color-bg)',
                          }}
                        >
                          {img.tipo === 'video' ? (
                            <div
                              style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                background: '#1a1a1a',
                              }}
                            >
                              <span style={{ color: '#fff', fontSize: '18px' }}>&#9654;</span>
                            </div>
                          ) : (
                            <img
                              src={getImagenUrl(img.url)}
                              alt=""
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                              onError={(e) => {
                                e.target.style.display = 'none';
                              }}
                            />
                          )}
                        </button>
                      ))}
                    </div>
                  )}

                  <div style={S.detailBody}>
                    <h2 style={S.detailName}>{productoDetalle.descripcion}</h2>

                    {productoDetalle.descripcion_completa &&
                      productoDetalle.descripcion_completa !== productoDetalle.descripcion && (
                        <p style={S.detailDesc}>{productoDetalle.descripcion_completa}</p>
                      )}
                    {productoDetalle.descripcion_corta && (
                      <p style={S.detailDesc}>{productoDetalle.descripcion_corta}</p>
                    )}

                    {productoDetalle.en_promocion && (
                      <div
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '8px',
                          background: 'linear-gradient(135deg, #c5221f 0%, #ea4335 100%)',
                          color: '#fff',
                          fontWeight: 800,
                          fontSize: '13px',
                          padding: '6px 14px',
                          borderRadius: '20px',
                          marginBottom: '8px',
                          boxShadow: '0 3px 8px rgba(197,34,31,0.3)',
                        }}
                      >
                        <FiZap size={14} />
                        OFERTA -{productoDetalle.porcentaje_descuento}%
                      </div>
                    )}
                    <div style={S.detailPrices}>
                      {enRevision || productoDetalle.precio_oculto ? (
                        <span style={S.detailPrecioOculto}>Precio oculto hasta que te aprueben</span>
                      ) : (
                        <>
                          <span style={S.detailPriceUsd}>
                            ${fmtMonto(productoDetalle.precio || 0)}
                          </span>
                          {productoDetalle.en_promocion &&
                            productoDetalle.precio_original != null && (
                              <span
                                style={{
                                  fontSize: '14px',
                                  color: 'var(--color-text-muted)',
                                  textDecoration: 'line-through',
                                }}
                              >
                                ${fmtMonto(productoDetalle.precio_original || 0)}
                              </span>
                            )}
                          {config?.mostrar_precio_bs !== false && Number.isFinite(tasaCambio) && tasaCambio > 0 && (
                            <span style={S.detailPriceBs}>
                              Bs {fmtMonto((productoDetalle.precio || 0) * tasaCambio)}
                            </span>
                          )}
                        </>
                      )}
                    </div>

                    <div style={S.detailTags}>
                      {productoDetalle.en_promocion && (
                        <span style={{ ...S.tagGreen, background: '#e8f5e9', color: '#0d904f', fontWeight: 700 }}>
                          Ahorras ${fmtMonto(((productoDetalle.precio_original || 0) - (productoDetalle.precio || 0)))}
                        </span>
                      )}
                      {productoDetalle.pesable && <span style={S.tagYellow}>Vendido por peso</span>}
                      {(productoDetalle.tags || []).map((t) => (
                        <span
                          key={t.id}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '3px',
                            fontSize: '11px',
                            fontWeight: 700,
                            padding: '3px 8px',
                            borderRadius: '8px',
                            background: t.color || '#0B1A4A',
                            color: '#fff',
                          }}
                        >
                          {t.icono && <span>{t.icono}</span>}
                          {t.nombre}
                        </span>
                      ))}
                      {!pva && !enRevision && !productoDetalle.precio_oculto && (
                      <span
                        style={{
                          ...S.tagGreen,
                          backgroundColor:
                            productoDetalle.tipo_producto === 'servicio'
                              ? '#e8eaed'
                              : productoDetalle.stock > 20
                                ? '#e8f5e9'
                                : productoDetalle.stock > 0
                                  ? '#fff3e0'
                                  : 'var(--color-danger-light)',
                          color:
                            productoDetalle.tipo_producto === 'servicio'
                              ? '#5f6368'
                              : productoDetalle.stock > 20
                                ? '#0d904f'
                                : productoDetalle.stock > 0
                                  ? '#ea8600'
                                  : 'var(--color-danger)',
                        }}
                      >
                        {productoDetalle.tipo_producto === 'servicio'
                          ? 'Servicio'
                          : productoDetalle.stock > 20
                            ? `${productoDetalle.stock} en stock`
                            : productoDetalle.stock > 0
                              ? `Solo ${productoDetalle.stock} disponibles`
                              : 'Agotado'}
                      </span>
                      )}
                    </div>

                    <div style={S.detailMeta}>
                      {productoDetalle.marca && (
                        <div style={S.metaItem}>
                          <span style={S.metaLabel}>Marca</span>
                          <span style={S.metaValue}>{productoDetalle.marca}</span>
                        </div>
                      )}
                      {productoDetalle.departamento && (
                        <div style={S.metaItem}>
                          <span style={S.metaLabel}>Departamento</span>
                          <span style={S.metaValue}>{productoDetalle.departamento}</span>
                        </div>
                      )}
                      {productoDetalle.grupo && (
                        <div style={S.metaItem}>
                          <span style={S.metaLabel}>Grupo</span>
                          <span style={S.metaValue}>{productoDetalle.grupo}</span>
                        </div>
                      )}
                      {productoDetalle.referencia && (
                        <div style={S.metaItem}>
                          <span style={S.metaLabel}>Referencia</span>
                          <span style={S.metaValue}>{productoDetalle.referencia}</span>
                        </div>
                      )}
                    </div>

                    <div style={S.detailActions}>
                      {esCorporativo ? (
                        <>
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '12px' }}>
                            <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--color-text-secondary)', marginBottom: '2px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                              Cantidad por sucursal
                            </div>
                            {!pva && (
                              <div style={{ fontSize: '12px', color: 'var(--color-text-secondary)' }}>
                                Disponible en total:{' '}
                                <strong style={{ color: 'var(--color-primary)' }}>
                                  {productoDetalle.pesable ? (stockMaxCorp / 1000).toFixed(2) + ' kg' : stockMaxCorp + ' und'}
                                </strong>
                                {' · '}Repartido: {productoDetalle.pesable ? (totalSeleccionadoCorp / 1000).toFixed(2) + ' kg' : totalSeleccionadoCorp + ' und'}
                              </div>
                            )}
                            {sedesCorporativas.map((s) => {
                              const id = s.id;
                              const cant = Number(cantidadesPorSede[id] || 0);
                              const step = productoDetalle.pesable ? 50 : 1;
                              const sinStock = !pva && restanteCorp <= 0;
                              return (
                                <div key={id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 10px', borderRadius: '10px', border: '1px solid var(--color-border)' }}>
                                  <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontSize: '13px', fontWeight: 600 }}>{s.nombre || ('Sucursal ' + id)}</div>
                                    {s.direccion && <div style={{ fontSize: '11px', color: 'var(--color-text-secondary)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{s.direccion}</div>}
                                  </div>
                                  <button
                                    onClick={() => setCantidadesPorSede((p) => ({ ...p, [id]: Math.max(0, (Number(p[id]) || 0) - step) }))}
                                    disabled={cant <= 0}
                                    style={{ ...S.cantBtn, opacity: cant <= 0 ? 0.3 : 1 }}
                                  >
                                    <FiMinus size={14} />
                                  </button>
                                  <span style={S.cantValue}>
                                    {productoDetalle.pesable ? (cant / 1000).toFixed(2) + ' kg' : cant}
                                  </span>
                                  <button
                                    onClick={() => setCantidadesPorSede((p) => ({ ...p, [id]: (Number(p[id]) || 0) + step }))}
                                    disabled={sinStock}
                                    style={{ ...S.cantBtn, opacity: sinStock ? 0.3 : 1 }}
                                  >
                                    <FiPlus size={14} />
                                  </button>
                                </div>
                              );
                            })}
                          </div>
                          <button
                            onClick={async () => {
                              if (!bloqueado) {
                                const etiqObj = [
                                  ...(productoDetalle.etiquetas || []).filter(e => etiquetasSeleccionadas.includes(e.id)),
                                  ...etiquetasManuales.map(e => ({ id: e.id, nombre: e.nombre, precio: 0 })),
                                ];
                                const ok = await corporativo.agregarProducto(productoDetalle, cantidadesPorSede, etiqObj);
                                if (ok !== false) cerrarDetalle();
                              }
                            }}
                            disabled={
                              bloqueado ||
                              corporativo.creandoPedido ||
                              totalSeleccionadoCorp <= 0
                            }
                            style={{
                              ...S.addBtn,
                              width: '100%',
                              opacity: bloqueado || totalSeleccionadoCorp <= 0 ? 0.5 : 1,
                              cursor: bloqueado || totalSeleccionadoCorp <= 0 ? 'default' : 'pointer',
                            }}
                          >
                            <FiShoppingCart size={18} /> Agregar por sucursal
                          </button>
                        </>
                      ) : (
                        <>
                          {/* Cantidad + boton de agregar, lado a lado */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <div style={S.cantSelector}>
                              <button
                                onClick={() => {
                                  if (!bloqueado)
                                    ajusteCantidad(productoDetalle, -(productoDetalle.pesable ? 50 : 1));
                                }}
                                disabled={bloqueado || cantidadDetalle <= (productoDetalle.pesable ? 50 : 1)}
                                style={S.cantBtn}
                              >
                                <FiMinus size={16} />
                              </button>
                              <span style={S.cantValue}>
                                {productoDetalle.pesable
                                  ? (cantidadDetalle / 1000).toFixed(2) + ' kg'
                                  : cantidadDetalle}
                              </span>
                              <button
                                onClick={() => {
                                  if (!bloqueado)
                                    ajusteCantidad(productoDetalle, productoDetalle.pesable ? 50 : 1);
                                }}
                                disabled={
                                  !pva && productoDetalle.tipo_producto !== 'servicio' && (bloqueado || cantidadDetalle >=
                                  (productoDetalle.pesable
                                    ? (productoDetalle.stock || 0) * 1000
                                    : (productoDetalle.stock || 0)))
                                }
                                style={S.cantBtn}
                              >
                                <FiPlus size={16} />
                              </button>
                            </div>
                            <button
                              onClick={() => {
                                if (!bloqueado) {
                                  const etiqObj = [
                                    ...(productoDetalle.etiquetas || []).filter(e => etiquetasSeleccionadas.includes(e.id)),
                                    ...etiquetasManuales.map(e => ({ id: e.id, nombre: e.nombre, precio: 0 })),
                                  ];
                                  agregarAlCarrito(productoDetalle, cantidadDetalle, etiqObj);
                                  cerrarDetalle();
                                }
                              }}
                              disabled={!pva && productoDetalle.tipo_producto !== 'servicio' && (bloqueado || !productoDetalle.stock || productoDetalle.stock <= 0 || creandoPedido)}
                              style={{
                                ...S.addBtn,
                                flex: 1,
                                opacity:
                                  pva || productoDetalle.tipo_producto === 'servicio'
                                    ? (!bloqueado && !creandoPedido ? 1 : 0.5)
                                    : (!bloqueado && productoDetalle.stock && productoDetalle.stock > 0 && !creandoPedido ? 1 : 0.5),
                                cursor:
                                  pva || productoDetalle.tipo_producto === 'servicio'
                                    ? (!bloqueado && !creandoPedido ? 'pointer' : 'default')
                                    : (!bloqueado && productoDetalle.stock && productoDetalle.stock > 0 && !creandoPedido
                                      ? 'pointer'
                                      : 'default'),
                              }}
                            >
                              <FiShoppingCart size={18} />
                              {enRevision
                                ? 'Solicitud en revisión'
                                : bloqueado
                                  ? 'Pedido en proceso'
                                  : creandoPedido
                                    ? 'Creando pedido...'
                                    : !pva && productoDetalle.tipo_producto !== 'servicio' && (!productoDetalle.stock || productoDetalle.stock <= 0)
                                      ? 'Producto agotado'
                                      : 'Agregar al carrito'}
                            </button>
                          </div>
                        </>
                      )}

                      {(productoDetalle.etiquetas || []).filter(e => e.activo !== false).length > 0 && (
                        <div style={{ marginTop: '12px' }}>
                          <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--color-text-secondary)', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            Personalizar
                          </div>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                            {productoDetalle.etiquetas.filter(e => e.activo !== false).map(et => {
                              const seleccionada = etiquetasSeleccionadas.includes(et.id);
                              return (
                                <button
                                  key={et.id}
                                  onClick={() => {
                                    setEtiquetasSeleccionadas(prev =>
                                      seleccionada ? prev.filter(id => id !== et.id) : [...prev, et.id]
                                    );
                                  }}
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    padding: '7px 12px',
                                    borderRadius: '999px',
                                    cursor: 'pointer',
                                    border: seleccionada ? '2px solid var(--color-secondary)' : '2px solid var(--color-border)',
                                    backgroundColor: seleccionada ? 'var(--color-secondary)' : 'var(--color-bg)',
                                    color: seleccionada ? '#fff' : 'var(--color-text)',
                                    fontSize: '13px',
                                    fontWeight: seleccionada ? 600 : 400,
                                    transition: 'all 0.15s ease',
                                    fontFamily: 'inherit',
                                  }}
                                >
                                  {seleccionada && (
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                                  )}
                                  {et.nombre}
                                  {et.precio > 0 && (
                                    <span style={{ fontSize: '12px', fontWeight: 700, opacity: 0.9 }}>
                                      +${fmtMonto(et.precio)}
                                    </span>
                                  )}
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      {/* Etiqueta manual (nota personalizada que llega a cocina) */}
                      {config?.notas_personalizacion_habilitadas !== false && (
                      <div style={{ marginTop: '12px' }}>
                        <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--color-text-secondary)', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                          Agregar una nota
                        </div>
                        {(etiquetasManuales.length > 0 || productoDetalle.etiquetas?.filter(e => e.activo !== false).length > 0) && (
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '10px' }}>
                            {etiquetasManuales.map(e => (
                              <span
                                key={e.id}
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  gap: '6px',
                                  padding: '6px 10px',
                                  borderRadius: '999px',
                                  backgroundColor: '#fef7e0',
                                  color: '#b06000',
                                  fontSize: '13px',
                                  fontWeight: 600,
                                  border: '1px solid #f3d78a',
                                }}
                              >
                                {e.nombre}
                                <button
                                  onClick={() => quitarEtiquetaManual(e.id)}
                                  style={{
                                    border: 'none',
                                    background: 'transparent',
                                    cursor: 'pointer',
                                    color: '#b06000',
                                    padding: 0,
                                    display: 'flex',
                                  }}
                                >
                                  <FiX size={13} />
                                </button>
                              </span>
                            ))}
                          </div>
                        )}
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <input
                            value={etiquetaManualInput}
                            onChange={(e) => setEtiquetaManualInput(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') { e.preventDefault(); agregarEtiquetaManual(); }
                            }}
                            placeholder="Ej: sin cebolla, bien cocido..."
                            maxLength={80}
                            style={{
                              flex: 1,
                              padding: '10px 12px',
                              borderRadius: '10px',
                              border: '1.5px solid var(--color-border)',
                              fontSize: '13px',
                              fontFamily: 'inherit',
                              color: 'var(--color-primary)',
                              backgroundColor: 'var(--color-surface)',
                              outline: 'none',
                            }}
                          />
                          <button
                            onClick={agregarEtiquetaManual}
                            disabled={!etiquetaManualInput.trim()}
                            style={{
                              padding: '0 16px',
                              borderRadius: '10px',
                              border: 'none',
                              backgroundColor: 'var(--color-secondary)',
                              color: '#fff',
                              fontSize: '13px',
                              fontWeight: 700,
                              cursor: etiquetaManualInput.trim() ? 'pointer' : 'default',
                              opacity: etiquetaManualInput.trim() ? 1 : 0.5,
                              fontFamily: 'inherit',
                            }}
                          >
                            Agregar
                          </button>
                        </div>
                      </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Carrito Sheet */}
        {productoDetalle && productoDetalle._carrito && !isMobile && (
          <div style={S.detailOverlay} onClick={cerrarDetalle}>
            <div
              style={{ ...S.detailModal, maxHeight: '80vh' }}
              onClick={(e) => e.stopPropagation()}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '16px',
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: '17px',
                    fontWeight: 700,
                    color: 'var(--color-primary)',
                  }}
                >
                  Tu pedido
                </h3>
                <button onClick={cerrarDetalle} style={S.detailClose}>
                  <FiX size={22} />
                </button>
              </div>

              {carrito.length === 0 ? (
                <p
                  style={{
                    color: 'var(--color-text-secondary)',
                    textAlign: 'center',
                    padding: '20px',
                  }}
                >
                  Tu carrito está vacío
                </p>
              ) : (
                <>
                  <div style={{ maxHeight: '50vh', overflowY: 'auto' }}>
                    {carrito.map((c, i) => (
                      <div key={i} style={S.cartItemRow}>
                        <div style={{ width: 40, height: 40, borderRadius: 8, flexShrink: 0, overflow: 'hidden', backgroundColor: 'var(--color-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          {getImagenUrl(c.imagen_url) ? (
                            <img src={getImagenUrl(c.imagen_url)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
                          ) : (
                            <FiPackage size={16} color="var(--color-text-muted)" />
                          )}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div
                            style={{
                              fontSize: '13px',
                              fontWeight: 600,
                              color: 'var(--color-primary)',
                            }}
                          >
                            {c.nombre}
                          </div>
                          <div
                            style={{
                              fontSize: '12px',
                              color: 'var(--color-text-secondary)',
                              marginTop: '2px',
                            }}
                          >
                            ${fmtMonto(c.precio || 0)}{config?.mostrar_precio_bs !== false ? ` / Bs ${fmtMonto(c.precio_bs || 0)}` : ''}
                          </div>
                          {c.pesable && (
                            <div style={{ fontSize: '10px', color: '#b06000' }}>
                              Pesable - {(c.cantidad / 1000).toFixed(2)} kg
                            </div>
                          )}
                          {c.etiquetas?.length > 0 && (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '4px' }}>
                              {c.etiquetas.map(et => (
                                <span key={et.id} style={{
                                  fontSize: '10px', fontWeight: 500,
                                  padding: '2px 6px', borderRadius: '6px',
                                  backgroundColor: 'var(--color-bg)',
                                  color: 'var(--color-text-secondary)',
                                }}>
                                  {et.nombre}{et.precio > 0 ? ` +$${fmtMonto(et.precio)}` : ''}
                                </span>
                              ))}
                            </div>
                          )}
                          {c.combo_id && c.componentes?.length > 0 && (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '5px' }}>
                              {c.componentes.map((comp, ci) => (
                                <div key={ci} style={{ fontSize: '11px', color: 'var(--color-text-secondary)' }}>
                                  {comp.nombre}
                                  {comp.etiquetas?.length > 0 && (
                                    <span style={{ color: 'var(--color-text-muted)' }}>
                                      {' · '}{comp.etiquetas.map((e) => e.nombre).join(', ')}
                                    </span>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <button
                            onClick={() => {
                              if (!bloqueado) actualizarCantidad(i, c.pesable ? -50 : -1);
                            }}
                            disabled={bloqueado || c.cantidad <= (c.pesable ? 50 : 1)}
                            style={{ ...S.cartCantBtn, opacity: bloqueado || c.cantidad <= (c.pesable ? 50 : 1) ? 0.3 : 1 }}
                          >
                            <FiMinus size={12} />
                          </button>
                          <span
                            style={{
                              fontSize: '13px',
                              fontWeight: 600,
                              minWidth: '40px',
                              textAlign: 'center',
                            }}
                          >
                            {c.pesable ? (c.cantidad / 1000).toFixed(2) + ' kg' : c.cantidad}
                          </span>
                          <button
                            onClick={() => {
                              if (!bloqueado) actualizarCantidad(i, c.pesable ? 50 : 1);
                            }}
                            disabled={!pva && (bloqueado || c.cantidad >= (c.pesable ? c.stock * 1000 : c.stock))}
                            style={{ ...S.cartCantBtn, opacity: !pva && (bloqueado || c.cantidad >= (c.pesable ? c.stock * 1000 : c.stock)) ? 0.3 : 1 }}
                          >
                            <FiPlus size={12} />
                          </button>
                          <button
                            onClick={() => {
                              if (!bloqueado) eliminarDelCarrito(i);
                            }}
                            disabled={bloqueado}
                            style={{
                              ...S.cartCantBtn,
                              color: bloqueado ? 'var(--color-text-muted)' : 'var(--color-danger)',
                              borderColor: bloqueado ? 'var(--color-border)' : '#FFCDD2',
                            }}
                          >
                            <FiX size={12} />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div
                    style={{
                      borderTop: '1px solid var(--color-border)',
                      padding: '12px 0 0',
                      marginTop: '12px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      fontSize: '15px',
                      fontWeight: 700,
                    }}
                  >
                    <span>Total</span>
                    <span style={{ color: 'var(--color-secondary)' }}>
                      ${fmtMonto(totalCarrito)}
                    </span>
                  </div>
                  {!bloqueado && (
                    <button onClick={irAConfirmarPedidoWrapper} style={S.confirmarPedidoBtn}>
                      <FiCheckCircle size={18} /> Confirmar pedido
                    </button>
                  )}
                </>
              )}
            </div>
          </div>
        )}

        {/* Carrito Sheet - Mobile fullscreen */}
        {productoDetalle && productoDetalle._carrito && isMobile && (
          <>
            <div onClick={cerrarDetalle} style={S.cartMobileOverlay} />
            <div style={S.cartMobilePanel}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '16px',
                  borderBottom: '1px solid var(--color-border)',
                  flexShrink: 0,
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: '17px',
                    fontWeight: 700,
                    color: 'var(--color-primary)',
                  }}
                >
                  Tu pedido
                </h3>
                <button onClick={cerrarDetalle} style={S.detailClose}>
                  <FiX size={22} />
                </button>
              </div>

              <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: '8px 16px' }}>
                {carrito.length === 0 ? (
                  <p
                    style={{
                      color: 'var(--color-text-secondary)',
                      textAlign: 'center',
                      padding: '40px 0',
                    }}
                  >
                    Tu carrito está vacío
                  </p>
                ) : (
                  carrito.map((c, i) => (
                    <div key={i} style={{ ...S.cartItemRow, padding: '12px 0' }}>
                      <div style={{ width: 44, height: 44, borderRadius: 10, flexShrink: 0, overflow: 'hidden', backgroundColor: 'var(--color-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {getImagenUrl(c.imagen_url) ? (
                          <img src={getImagenUrl(c.imagen_url)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
                        ) : (
                          <FiPackage size={18} color="var(--color-text-muted)" />
                        )}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            fontSize: '14px',
                            fontWeight: 600,
                            color: 'var(--color-primary)',
                          }}
                        >
                          {c.nombre}
                        </div>
                        <div
                          style={{
                            fontSize: '13px',
                            color: 'var(--color-text-secondary)',
                            marginTop: '3px',
                          }}
                        >
                          ${fmtMonto(c.precio || 0)} / Bs {fmtMonto(c.precio_bs || 0)}
                        </div>
                        {c.pesable && (
                          <div style={{ fontSize: '11px', color: '#b06000', marginTop: '2px' }}>
                            Pesable - {(c.cantidad / 1000).toFixed(2)} kg
                          </div>
                        )}
                        {c.combo_id && Array.isArray(c.componentes) && c.componentes.length > 0 && (
                          <div style={{ marginTop: '4px', paddingLeft: '2px' }}>
                            {c.componentes.map((comp, ci) => {
                              const compEtiq = Array.isArray(comp.etiquetas) ? comp.etiquetas : [];
                              return (
                                <div
                                  key={ci}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                    fontSize: '11px',
                                    padding: '1px 0',
                                  }}
                                >
                                  <span
                                    style={{
                                      display: 'inline-block',
                                      width: 4,
                                      height: 4,
                                      borderRadius: '50%',
                                      backgroundColor: '#f0b400',
                                      flexShrink: 0,
                                    }}
                                  />
                                  <span style={{ color: 'var(--color-text-secondary)' }}>
                                    {comp.nombre}
                                  </span>
                                  {compEtiq.length > 0 && (
                                    <span style={{ color: 'var(--color-text-muted)' }}>
                                      ({compEtiq.map((e) => e.nombre).join(', ')})
                                    </span>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <button
                          onClick={() => {
                            if (!bloqueado) actualizarCantidad(i, c.pesable ? -50 : -1);
                          }}
                          disabled={bloqueado || c.cantidad <= (c.pesable ? 50 : 1)}
                          style={{ ...S.cartCantBtnLarge, opacity: bloqueado || c.cantidad <= (c.pesable ? 50 : 1) ? 0.3 : 1 }}
                        >
                          <FiMinus size={16} />
                        </button>
                        <span
                          style={{
                            fontSize: '14px',
                            fontWeight: 600,
                            minWidth: '50px',
                            textAlign: 'center',
                          }}
                        >
                          {c.pesable ? (c.cantidad / 1000).toFixed(2) + ' kg' : c.cantidad}
                        </span>
                        <button
                          onClick={() => {
                            if (!bloqueado) actualizarCantidad(i, c.pesable ? 50 : 1);
                          }}
                          disabled={!pva && (bloqueado || c.cantidad >= (c.pesable ? c.stock * 1000 : c.stock))}
                          style={{ ...S.cartCantBtnLarge, opacity: !pva && (bloqueado || c.cantidad >= (c.pesable ? c.stock * 1000 : c.stock)) ? 0.3 : 1 }}
                        >
                          <FiPlus size={16} />
                        </button>
                        <button
                          onClick={() => {
                            if (!bloqueado) eliminarDelCarrito(i);
                          }}
                          disabled={bloqueado}
                          style={{
                            ...S.cartCantBtnLarge,
                            color: bloqueado ? 'var(--color-text-muted)' : 'var(--color-danger)',
                            borderColor: bloqueado ? 'var(--color-border)' : '#FFCDD2',
                          }}
                        >
                          <FiX size={16} />
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {carrito.length > 0 && (
                <div
                  style={{
                    borderTop: '1px solid var(--color-border)',
                    padding: '16px',
                    flexShrink: 0,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      fontSize: '16px',
                      fontWeight: 700,
                      marginBottom: bloqueado ? 0 : '12px',
                    }}
                  >
                    <span>Total</span>
                    <span style={{ color: 'var(--color-secondary)' }}>
                      ${fmtMonto(totalCarrito)}
                    </span>
                  </div>
                  {!bloqueado && (
                    <button onClick={irAConfirmarPedidoWrapper} style={S.confirmarPedidoBtn}>
                      <FiCheckCircle size={18} /> Confirmar pedido
                    </button>
                  )}
                </div>
              )}
            </div>
          </>
        )}

        {/* Confirmar iniciar pedido modal */}
        {confirmarIniciarPedido && (
          <div
            onClick={() => setConfirmarIniciarPedido(null)}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2000,
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                backgroundColor: 'var(--color-surface)',
                borderRadius: '20px',
                padding: '24px',
                maxWidth: '360px',
                width: '90%',
                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                textAlign: 'center',
              }}
            >
              <div
                style={{
                  width: '56px',
                  height: '56px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--color-bg-hover)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 16px',
                }}
              >
                <FiShoppingCart size={28} color="var(--color-secondary)" />
              </div>
              <h3
                style={{
                  margin: '0 0 8px',
                  fontSize: '18px',
                  fontWeight: 700,
                  color: 'var(--color-primary)',
                }}
              >
                Iniciar pedido?
              </h3>
              <p
                style={{
                  fontSize: '14px',
                  color: 'var(--color-text-secondary)',
                  margin: '0 0 20px',
                  lineHeight: 1.5,
                }}
              >
                Quieres iniciar un pedido con{' '}
                <strong>
                  {confirmarIniciarPedido.prod.descripcion || confirmarIniciarPedido.prod.nombre}
                </strong>
                ?
              </p>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button
                  onClick={() => setConfirmarIniciarPedido(null)}
                  style={{
                    flex: 1,
                    padding: '12px',
                    borderRadius: '12px',
                    border: '1px solid var(--color-border)',
                    backgroundColor: 'var(--color-surface)',
                    color: 'var(--color-text-secondary)',
                    fontSize: '14px',
                    fontWeight: 600,
                    cursor: 'pointer',
                  }}
                >
                  Cancelar
                </button>
                <button
                  onClick={() => {
                    const { prod, cant, etiquetas } = confirmarIniciarPedido;
                    setConfirmarIniciarPedido(null);
                    cerrarDetalle();
                    ejecutarAgregarAlCarrito(prod, cant, etiquetas);
                  }}
                  style={{
                    flex: 1,
                    padding: '12px',
                    borderRadius: '12px',
                    border: 'none',
                    backgroundColor: 'var(--color-secondary)',
                    color: 'var(--color-surface)',
                    fontSize: '14px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px',
                  }}
                >
                  <FiCheckCircle size={16} />
                  Si, iniciar pedido
                </button>
              </div>
            </div>
          </div>
        )}

        {mostrarGuardarDireccion && (
          <div
            onClick={() => {
              if (!guardandoDireccion) {
                setMostrarGuardarDireccion(false);
                setNombreDireccion('');
              }
            }}
            style={M.overlay}
          >
            <div onClick={(e) => e.stopPropagation()} style={M.modal}>
              <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                <div
                  style={{
                    width: '56px',
                    height: '56px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--color-bg-hover)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 14px',
                  }}
                >
                  <FiMapPin size={26} color="var(--color-secondary)" />
                </div>
                <h3
                  style={{
                    margin: '0 0 6px',
                    fontSize: '17px',
                    fontWeight: 700,
                    color: 'var(--color-primary)',
                  }}
                >
                  Guardar direccion?
                </h3>
                <p
                  style={{
                    fontSize: '13px',
                    color: 'var(--color-text-secondary)',
                    margin: 0,
                    lineHeight: 1.4,
                  }}
                >
                  Agrega un nombre para usar esta direccion en futuros pedidos.
                </p>
              </div>

              <input
                placeholder="Ej: Casa, Trabajo, Apartamento..."
                value={nombreDireccion}
                onChange={(e) => setNombreDireccion(e.target.value)}
                autoFocus
                style={M.nombreInput}
              />

              <div style={M.direccionPreview}>
                <FiMapPin
                  size={14}
                  color="var(--color-text-secondary)"
                  style={{ flexShrink: 0, marginTop: '2px' }}
                />
                <span
                  style={{
                    fontSize: '12px',
                    color: 'var(--color-text-secondary)',
                    lineHeight: 1.4,
                  }}
                >
                  {ubicacionActual}
                </span>
              </div>

              <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
                <button
                  onClick={() => {
                    setMostrarGuardarDireccion(false);
                    setNombreDireccion('');
                  }}
                  disabled={guardandoDireccion}
                  style={M.btnCancel}
                >
                  Ahora no
                </button>
                <button
                  onClick={guardarDireccionFrecuente}
                  disabled={!nombreDireccion.trim() || guardandoDireccion}
                  style={M.btnGuardar}
                >
                  {guardandoDireccion ? 'Guardando...' : 'Guardar'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Toast */}
        {toast && <div style={S.toastFloating}>{toast.texto}</div>}

        {/* FAB Carrito - Desktop */}
        {!isMobile && carrito.length > 0 && (
          <button
            onClick={() => setProductoDetalle({ _carrito: true })}
            style={SD.fab}
            data-tutorial="carrito-fab"
          >
            <FiShoppingCart size={22} color="#fff" />
            <span
              key={carrito.length}
              style={{ ...SD.fabBadge, animation: 'fabPulse 0.35s ease' }}
            >
              {carrito.length}
            </span>
          </button>
        )}
      </div>

      {tagIntroAbierto && (
        <div
          onClick={() => setTagIntroAbierto(false)}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 3000,
            background: 'rgba(15,23,42,0.55)',
            display: 'flex',
            alignItems: isMobile ? 'flex-end' : 'center',
            justifyContent: 'center',
            padding: isMobile ? 0 : 20,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '100%',
              maxWidth: '480px',
              maxHeight: isMobile ? '80vh' : '70vh',
              background: 'var(--color-surface)',
              borderRadius: isMobile ? '20px 20px 0 0' : '20px',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              animation: 'slideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1)',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '18px 20px',
                borderBottom: '1px solid var(--color-border)',
                flexShrink: 0,
              }}
            >
              <div>
                <h3 style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: 'var(--color-primary)' }}>
                  Explora por etiqueta
                </h3>
                <p style={{ margin: '2px 0 0', fontSize: '12px', color: 'var(--color-text-secondary)' }}>
                  Selecciona una etiqueta para ver sus productos
                </p>
              </div>
              <button
                onClick={() => setTagIntroAbierto(false)}
                aria-label="Cerrar"
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  border: 'none',
                  background: 'var(--color-bg-hover)',
                  color: 'var(--color-text-muted)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  flexShrink: 0,
                }}
              >
                <FiX size={16} />
              </button>
            </div>

            <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: '16px 20px 20px' }}>
              {tags.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '32px 0', color: 'var(--color-text-muted)', fontSize: '13px' }}>
                  No hay etiquetas disponibles.
                </div>
              ) : (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                  {tags.map((t) => {
                    const sel = tagSeleccionado === t.id;
                    return (
                      <button
                        key={t.id}
                        onClick={() => {
                          seleccionarTag(t.id);
                          setTagIntroAbierto(false);
                        }}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '8px',
                          padding: '11px 16px',
                          borderRadius: '14px',
                          border: sel ? `2px solid ${t.color}` : '1px solid rgba(0,0,0,0.06)',
                          background: t.color,
                          color: '#fff',
                          fontSize: '13px',
                          fontWeight: 700,
                          cursor: 'pointer',
                          fontFamily: 'inherit',
                          boxShadow: sel ? `0 3px 10px ${t.color}40` : `0 2px 6px ${t.color}26`,
                        }}
                      >
                        {t.icono && <span style={{ fontSize: '16px' }}>{t.icono}</span>}
                        <span>{t.nombre}</span>
                        <span
                          style={{
                            fontSize: '10px',
                            fontWeight: 700,
                            padding: '1px 7px',
                            borderRadius: '10px',
                            background: 'rgba(255,255,255,0.25)',
                            color: '#fff',
                          }}
                        >
                          {t.total_productos}
                        </span>
                      </button>
                    );
                  })}
                </div>
              )}
            </div>

            <div style={{ padding: '12px 20px', borderTop: '1px solid var(--color-border)', flexShrink: 0 }}>
              <button
                onClick={() => setTagIntroAbierto(false)}
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '12px',
                  border: 'none',
                  background: 'var(--color-secondary)',
                  color: '#fff',
                  fontSize: '14px',
                  fontWeight: 700,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                }}
              >
                Ver todos los productos
              </button>
            </div>
          </div>
        </div>
      )}

      {cambiarDirAbierto && (
        <div
          onClick={() => {
            setCambiarDirAbierto(false);
            setConfirmarSedeCambio(null);
          }}
          style={M.overlay}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ ...M.modal, maxWidth: '400px' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 16,
              }}
            >
              <h3
                style={{ margin: 0, fontSize: 17, fontWeight: 700, color: 'var(--color-primary)' }}
              >
                Cambiar dirección de entrega
              </h3>
              <button
                onClick={() => {
                  setCambiarDirAbierto(false);
                  setConfirmarSedeCambio(null);
                }}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: 'var(--color-text-muted)',
                  padding: 4,
                }}
              >
                <FiX size={20} />
              </button>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
                maxHeight: 360,
                overflowY: 'auto',
              }}
            >
              {dirsCambiar.map((dir) => (
                <button
                  key={dir.id}
                  onClick={() => seleccionarDirCambio(dir)}
                  disabled={cambiandoDirSel}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '12px 14px',
                    borderRadius: 14,
                    border: dir.principal ? '2px solid #f0b400' : '1px solid var(--color-border)',
                    backgroundColor: dir.principal ? '#fffdf5' : 'var(--color-surface)',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontFamily: 'inherit',
                    opacity: cambiandoDirSel ? 0.6 : 1,
                  }}
                >
                  <FiHome
                    size={18}
                    color={dir.principal ? '#f0b400' : 'var(--color-secondary)'}
                    style={{ flexShrink: 0 }}
                  />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--color-text)' }}>
                      {dir.nombre || 'Sin nombre'}
                      {dir.principal && (
                        <span
                          style={{ fontSize: 10, color: '#f0b400', marginLeft: 6, fontWeight: 500 }}
                        >
                          FAVORITA
                        </span>
                      )}
                    </div>
                    <div
                      style={{
                        fontSize: 11,
                        color: 'var(--color-text-secondary)',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        marginTop: 2,
                      }}
                    >
                      {dir.direccion}
                    </div>
                  </div>
                </button>
              ))}
            </div>
            <button
              onClick={() => {
                setCambiarDirAbierto(false);
                setEtapa('ubicacion');
              }}
              style={{
                width: '100%',
                marginTop: 12,
                padding: '12px',
                borderRadius: 14,
                border: '1.5px solid var(--color-border)',
                backgroundColor: 'transparent',
                color: 'var(--color-text-secondary)',
                fontSize: 13,
                fontWeight: 600,
                cursor: 'pointer',
                fontFamily: 'inherit',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 8,
              }}
            >
              <FiMapPin size={16} /> Nueva direccion
            </button>
          </div>
        </div>
      )}

      {confirmarSedeCambio && (
        <div onClick={() => setConfirmarSedeCambio(null)} style={M.overlay}>
          <div onClick={(e) => e.stopPropagation()} style={M.modal}>
            <div style={{ textAlign: 'center', marginBottom: 16 }}>
              <FiMapPin size={36} color="var(--color-secondary)" style={{ marginBottom: 8 }} />
              <h3
                style={{
                  margin: '0 0 8px',
                  fontSize: 16,
                  fontWeight: 700,
                  color: 'var(--color-primary)',
                }}
              >
                Cambio de sede
              </h3>
              <p
                style={{
                  fontSize: 13,
                  color: 'var(--color-text-secondary)',
                  lineHeight: 1.5,
                  margin: 0,
                }}
              >
                La nueva direccion pertenece a la sede{' '}
                <strong>{confirmarSedeCambio.sedeNueva?.nombre || 'otra'}</strong>.
                {pedidoId
                  ? ' Tu pedido actual será cancelado y podrás iniciar uno nuevo en esta sede.'
                  : ' Se actualizará la ubicación de entrega.'}
              </p>
            </div>
            <div style={{ display: 'flex', gap: 10 }}>
              <button
                onClick={() => setConfirmarSedeCambio(null)}
                style={{
                  flex: 1,
                  padding: '12px',
                  borderRadius: 12,
                  border: '1px solid var(--color-border)',
                  backgroundColor: 'var(--color-surface)',
                  color: 'var(--color-text-secondary)',
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                }}
              >
                Cancelar
              </button>
              <button
                onClick={cancelarEIniciarNuevo}
                style={{
                  flex: 1,
                  padding: '12px',
                  borderRadius: 12,
                  border: 'none',
                  backgroundColor: 'var(--color-secondary)',
                  color: 'var(--color-surface)',
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                }}
              >
                {pedidoId ? 'Cancelar e iniciar nuevo' : 'Cambiar sede'}
              </button>
            </div>
          </div>
        </div>
      )}
      {visorOpen && (
        <VisorImagen
          images={visorOpen.images}
          startIdx={visorOpen.startIdx || 0}
          onClose={() => setVisorOpen(null)}
        />
      )}

      {/* Bottom Sheet de categorías - Mobile */}
      {showMobileDeptos && (
        <div
          onClick={() => setShowMobileDeptos(false)}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 1000,
            background: 'rgba(0,0,0,0.4)',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            animation: 'fadeIn 0.2s ease',
          }}
        >
          <style>{`
            @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
            @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
          `}</style>
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '100%',
              maxWidth: '500px',
              maxHeight: '85vh',
              background: '#fff',
              borderRadius: '20px 20px 0 0',
              display: 'flex',
              flexDirection: 'column',
              animation: 'slideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1)',
              overflow: 'hidden',
            }}
          >
            {/* Header */}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '16px 20px',
                borderBottom: '1px solid #f1f3f4',
                flexShrink: 0,
              }}
            >
              <h3 style={{ margin: 0, fontSize: '17px', fontWeight: 700, color: '#202124' }}>
                Categorías
              </h3>
              <button
                onClick={() => setShowMobileDeptos(false)}
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  border: 'none',
                  background: '#f1f3f4',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  fontSize: '16px',
                  color: '#5f6368',
                }}
              >
                <FiX size={18} />
              </button>
            </div>

            {/* Scrollable content */}
            <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', padding: '12px 16px 24px' }}>
              {/* Modelos - primero */}
          {categorias.length > 0 && (
                <div style={{ marginBottom: '16px' }}>
                  <div style={{ fontSize: '13px', fontWeight: 700, color: '#5f6368', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px', paddingLeft: '4px' }}>
                    Modelos
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '8px' }}>
                    {categorias.map((c, idx) => {
                      const sel = categoriaSeleccionada === c.categoria;
                      const color = MODELO_PALETTE[idx % MODELO_PALETTE.length];
                      return (
                        <button
                          key={c.categoria}
                          onClick={() => {
                            seleccionarCategoria(c.categoria);
                            setShowMobileDeptos(false);
                          }}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '12px',
                            borderRadius: '12px',
                            border: sel ? `1.5px solid ${color}` : '1px solid #e8eaed',
                            background: sel ? `${color}08` : '#fff',
                            cursor: 'pointer',
                            fontFamily: 'inherit',
                            textAlign: 'left',
                            minWidth: 0,
                          }}
                        >
                          <div style={{ width: '34px', height: '34px', borderRadius: '10px', background: `${color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            <CarIcon size={17} color={color} />
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: '12px', fontWeight: sel ? 700 : 500, color: sel ? color : '#202124', lineHeight: 1.3, wordBreak: 'break-word' }}>
                              {c.categoria}
                            </div>
                            <div style={{ fontSize: '11px', color: '#5f6368', marginTop: '2px' }}>
                              {c.total_productos} productos
                            </div>
                          </div>
                          {sel && <FiCheckCircle size={16} color={color} style={{ flexShrink: 0 }} />}
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Todos */}
              <button
                onClick={() => {
                  setDepSeleccionado(null);
                  seleccionarCategoria(categoriaSeleccionada);
                  seleccionarTag(tagSeleccionado);
                  seleccionarMarca(marcaSeleccionada);
                  setShowMobileDeptos(false);
                }}
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '14px 16px',
                  borderRadius: '12px',
                  border: 'none',
                  background: !depSeleccionado ? '#e8f0fe' : '#f8f9fa',
                  cursor: 'pointer',
                  fontFamily: 'inherit',
                  marginBottom: '12px',
                }}
              >
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '12px',
                    background: !depSeleccionado ? '#1a73e8' : '#dadce0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <FiGrid size={20} color={!depSeleccionado ? '#fff' : '#5f6368'} />
                </div>
                <div style={{ textAlign: 'left' }}>
                  <div style={{ fontSize: '15px', fontWeight: 600, color: '#202124' }}>
                    Todos los productos
                  </div>
                  <div style={{ fontSize: '12px', color: '#5f6368', marginTop: '2px' }}>
                    {productos.length} productos disponibles
                  </div>
                </div>
                {!depSeleccionado && !categoriaSeleccionada && !tagSeleccionado && !marcaSeleccionada && (
                  <div style={{ marginLeft: 'auto' }}>
                    <FiCheckCircle size={20} color="#1a73e8" />
                  </div>
                )}
              </button>

              {/* Marcas */}
              {marcas.length > 0 && (
                <div style={{ marginBottom: '12px' }}>
                  <div style={{ fontSize: '13px', fontWeight: 700, color: '#5f6368', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px', paddingLeft: '4px' }}>
                    Marcas
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {marcas.map((m) => {
                      const sel = marcaSeleccionada === m.marca;
                      return (
                        <button
                          key={m.marca}
                          onClick={() => {
                            seleccionarMarca(m.marca);
                            setShowMobileDeptos(false);
                          }}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '8px 14px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: 600,
                            cursor: 'pointer',
                            border: sel ? '1.5px solid #0d8043' : '1px solid #e8eaed',
                            background: sel ? '#0d804310' : '#f8f9fa',
                            color: sel ? '#0d8043' : '#3c4043',
                            fontFamily: 'inherit',
                          }}
                        >
                          <FiTag size={13} />
                          {m.marca}
                          <span style={{ fontSize: '11px', opacity: 0.7 }}>{m.total_productos}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Etiquetas */}
              {tags.length > 0 && (
                <div style={{ marginBottom: '12px' }}>
                  <div style={{ fontSize: '13px', fontWeight: 700, color: '#5f6368', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '10px', paddingLeft: '4px' }}>
                    Etiquetas
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                    {tags.map((t) => {
                      const sel = tagSeleccionado === t.id;
                      const esNuevo = tagNuevo && tagNuevo.id === t.id;
                      return (
                        <button
                          key={t.id}
                          onClick={() => {
                            seleccionarTag(t.id);
                            setShowMobileDeptos(false);
                          }}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            padding: '8px 14px',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: sel || esNuevo ? 700 : 600,
                            cursor: 'pointer',
                            border: sel ? `1.5px solid ${t.color}` : esNuevo ? '1.5px solid #c5221f' : '1px solid #e8eaed',
                            background: esNuevo && !sel ? 'linear-gradient(120deg, #c5221f 0%, #ea4335 100%)' : sel ? `${t.color}10` : '#f8f9fa',
                            color: esNuevo && !sel ? '#fff' : sel ? t.color : '#3c4043',
                            fontFamily: 'inherit',
                          }}
                        >
                          {t.icono && <span>{t.icono}</span>}
                          {t.nombre}
                          {esNuevo && !sel && <span style={{ fontSize: '10px', fontWeight: 800, textTransform: 'uppercase' }}>Nuevo</span>}
                          <span style={{ fontSize: '11px', opacity: 0.7 }}>{t.total_productos}</span>
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Grupos */}
              {Object.entries(groupedDeptos)
                .sort(([a], [b]) => a.localeCompare(b))
                .map(([grupo, depts], idx) => {
                  const PALETTE = [
                    '#1a73e8', '#0d8043', '#c5221f', '#e37400', '#7b1fa2',
                    '#007b83', '#1967d2', '#9334e6', '#188038', '#d93025',
                    '#f9ab00', '#185abc', '#129eaf', '#ea8600', '#a142f4',
                  ];
                  const color = PALETTE[idx % PALETTE.length];
                  const isOpen = mobileExpanded[grupo] !== false;
                  return (
                    <div
                      key={grupo}
                      style={{
                        borderRadius: '14px',
                        border: '1px solid #e8eaed',
                        marginBottom: '10px',
                        overflow: 'hidden',
                      }}
                    >
                      <button
                        onClick={() =>
                          setMobileExpanded((prev) => ({ ...prev, [grupo]: !prev[grupo] }))
                        }
                        style={{
                          width: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '12px',
                          padding: '14px 16px',
                          border: 'none',
                          background: isOpen ? `${color}06` : '#fff',
                          cursor: 'pointer',
                          fontFamily: 'inherit',
                          borderLeft: `4px solid ${color}`,
                        }}
                      >
                        <div
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '10px',
                            background: `${color}15`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <FiFolder size={16} color={color} />
                        </div>
                        <div style={{ flex: 1, textAlign: 'left' }}>
                          <div style={{ fontSize: '14px', fontWeight: 600, color: '#202124' }}>
                            {grupo}
                          </div>
                          <div style={{ fontSize: '11px', color: '#5f6368', marginTop: '1px' }}>
                            {depts.length} subcategorías
                          </div>
                        </div>
                        <span
                          style={{
                            fontSize: '11px',
                            fontWeight: 600,
                            padding: '2px 8px',
                            borderRadius: '10px',
                            background: `${color}12`,
                            color,
                          }}
                        >
                          {depts.length}
                        </span>
                        <FiChevronRight
                          size={16}
                          color="#9aa0a6"
                          style={{
                            transition: 'transform 0.2s',
                            transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                          }}
                        />
                      </button>
                      {isOpen && (
                        <div
                          style={{
                            padding: '4px 16px 16px',
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '8px',
                          }}
                        >
                          {depts.map((d) => (
                            <button
                              key={d.codigo}
                              onClick={() => {
                                seleccionarDepartamento(d.codigo);
                                setShowMobileDeptos(false);
                              }}
                              style={{
                                padding: '8px 14px',
                                borderRadius: '20px',
                                border: depSeleccionado === d.codigo
                                  ? `1.5px solid ${color}`
                                  : '1px solid #e8eaed',
                                background: depSeleccionado === d.codigo
                                  ? `${color}10`
                                  : '#f8f9fa',
                                color: depSeleccionado === d.codigo ? color : '#3c4043',
                                fontSize: '13px',
                                fontWeight: depSeleccionado === d.codigo ? 600 : 400,
                                cursor: 'pointer',
                                fontFamily: 'inherit',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {d.nombre}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      )}

      {/* Modal de combo con personalizacion */}
      {comboDetalle && (() => {
        const instancias = instanciasCombo(comboDetalle.items);
        const extra = instancias.reduce((s, it) => {
          const incluidos = new Set((it.etiquetas || []).map((e) => e.id));
          const seleccionados = comboSelEtiquetas[`${it.codigo_producto}#${it._instancia}`] || [];
          const suma = (it.etiquetas_disponibles || []).reduce((t, e) => {
            if (!incluidos.has(e.id) && seleccionados.includes(e.id)) return t + (e.precio || 0);
            return t;
          }, 0);
          return s + suma;
        }, 0);
        const totalCombo = (comboDetalle.precio || 0) + extra;
        return (
          <div
            style={{ ...S.detailOverlay, alignItems: isMobile ? 'flex-end' : 'center' }}
            onClick={cerrarComboDetalle}
          >
            <div
              style={{
                ...S.detailModal,
                borderRadius: isMobile ? '20px 20px 0 0' : '20px',
                maxWidth: '480px',
                maxHeight: isMobile ? '90vh' : '85vh',
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <button onClick={cerrarComboDetalle} style={S.detailClose}>
                <FiX size={22} />
              </button>

              <div style={S.detailImage}>
                {(() => {
                  const media = Array.isArray(comboDetalle.imagenes) && comboDetalle.imagenes.length > 0
                    ? comboDetalle.imagenes
                    : comboDetalle.imagen_url
                      ? [{ url: comboDetalle.imagen_url, tipo: 'imagen', prioridad: 1 }]
                      : [];
                  const actual = media[comboGalIdx] || media[0];
                  if (!actual) return <FiPackage size={64} color="var(--color-secondary)" />;
                  return actual.tipo === 'video' ? (
                    <video
                      src={getImagenUrl(actual.url)}
                      controls
                      playsInline
                      style={{ width: '100%', height: '100%', objectFit: 'cover', background: '#000' }}
                    />
                  ) : (
                    <img
                      src={getImagenUrl(actual.url)}
                      alt={comboDetalle.nombre}
                      style={{ ...S.detailImg, objectFit: 'cover', cursor: media.length > 1 ? 'zoom-in' : 'default' }}
                      onClick={() => media.length > 1 && setVisorOpen({ images: media, startIdx: comboGalIdx })}
                      onError={(e) => { e.currentTarget.style.display = 'none'; }}
                    />
                  );
                })()}
              </div>

              {Array.isArray(comboDetalle.imagenes) && comboDetalle.imagenes.length > 1 && (
                <div
                  style={{
                    display: 'flex',
                    gap: '8px',
                    marginBottom: '16px',
                    overflowX: 'auto',
                    paddingBottom: '4px',
                  }}
                >
                  {comboDetalle.imagenes.map((img, idx) => (
                    <button
                      key={idx}
                      onClick={() => setComboGalIdx(idx)}
                      style={{
                        width: '56px',
                        height: '56px',
                        borderRadius: '10px',
                        overflow: 'hidden',
                        flexShrink: 0,
                        border:
                          comboGalIdx === idx
                            ? '2px solid var(--color-primary)'
                            : '2px solid transparent',
                        padding: 0,
                        cursor: 'pointer',
                        background: 'var(--color-bg)',
                      }}
                    >
                      {img.tipo === 'video' ? (
                        <div
                          style={{
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#1a1a1a',
                          }}
                        >
                          <span style={{ color: '#fff', fontSize: '18px' }}>&#9654;</span>
                        </div>
                      ) : (
                        <img
                          src={getImagenUrl(img.url)}
                          alt=""
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          onError={(e) => { e.target.style.display = 'none'; }}
                        />
                      )}
                    </button>
                  ))}
                </div>
              )}

              <div style={S.detailBody}>
                <h2 style={S.detailName}>{comboDetalle.nombre}</h2>
                {comboDetalle.descripcion && <p style={S.detailDesc}>{comboDetalle.descripcion}</p>}

                <div style={{ ...S.detailPrices, alignItems: 'center', flexWrap: 'wrap' }}>
                  <span style={S.detailPriceUsd}>${fmtMonto(totalCombo)}</span>
                  {config?.mostrar_precio_bs !== false &&
                    Number.isFinite(tasaCambio) &&
                    tasaCambio > 0 && (
                      <span style={S.detailPriceBs}>Bs {fmtMonto(totalCombo * tasaCambio)}</span>
                    )}
                  {comboDetalle.precio_sin_descuento > 0 &&
                    comboDetalle.precio_sin_descuento > comboDetalle.precio && (
                      <span
                        style={{
                          fontSize: '14px',
                          color: 'var(--color-text-secondary)',
                          textDecoration: 'line-through',
                        }}
                      >
                        ${fmtMonto(comboDetalle.precio_sin_descuento)}
                      </span>
                    )}
                  {comboDetalle.ahorro > 0 && (
                    <span
                      style={{
                        fontSize: '11px',
                        fontWeight: 700,
                        color: '#137333',
                        background: '#e6f4ea',
                        padding: '3px 8px',
                        borderRadius: '20px',
                      }}
                    >
                      Ahorras ${fmtMonto(comboDetalle.ahorro)}
                    </span>
                  )}
                </div>

                <div
                  style={{
                    fontSize: '12px',
                    fontWeight: 700,
                    color: 'var(--color-text-secondary)',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    margin: '12px 0 8px',
                  }}
                >
                  Componentes del combo
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '16px' }}>
                  {comboDetalle.items.flatMap((item) => {
                    const disponibles = item.etiquetas_disponibles || [];
                    const cant = Math.max(1, parseInt(item.cantidad, 10) || 1);
                    // Sin personalizaciones: no separar por unidad; mostrar nombre × cantidad.
                    if (disponibles.length === 0) {
                      return [
                        <div
                          key={item.codigo_producto}
                          style={{
                            borderRadius: '12px',
                            border: '1px solid var(--color-border)',
                            background: 'var(--color-bg)',
                            padding: '12px 14px',
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                            <div style={{ fontSize: '13px', fontWeight: 600, color: 'var(--color-primary)' }}>
                              {item.nombre}
                            </div>
                            <div
                              style={{
                                fontSize: '12px',
                                fontWeight: 700,
                                color: 'var(--color-text-secondary)',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              × {cant}
                            </div>
                          </div>
                        </div>,
                      ];
                    }
                    // Con personalizaciones: una fila por unidad.
                    return Array.from({ length: cant }).map((_, idx) => {
                      const it = { ...item, _instancia: idx };
                      const seleccionados = comboSelEtiquetas[`${item.codigo_producto}#${idx}`] || [];
                      const esMultiple = cant > 1;
                      return (
                        <div
                          key={`${item.codigo_producto}#${idx}`}
                          style={{
                            borderRadius: '12px',
                            border: '1px solid var(--color-border)',
                            background: 'var(--color-bg)',
                            padding: '12px 14px',
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                            <div style={{ fontSize: '13px', fontWeight: 600, color: 'var(--color-primary)' }}>
                              {esMultiple && (
                                <span style={{ color: 'var(--color-secondary)', fontWeight: 700, marginRight: '6px' }}>
                                  #{idx + 1}
                                </span>
                              )}
                              {it.nombre}
                            </div>
                            <div
                              style={{
                                fontSize: '11px',
                                fontWeight: 600,
                                color: 'var(--color-text-muted)',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              Incluido
                            </div>
                          </div>
                          {disponibles.length > 0 && (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '8px' }}>
                              {disponibles.map((et) => {
                                const sel = seleccionados.includes(et.id);
                                if (et.incluida) {
                                  return (
                                    <span
                                      key={et.id}
                                      style={{
                                        padding: '5px 10px',
                                        borderRadius: '20px',
                                        border: '1px solid var(--color-border)',
                                        background: 'var(--color-bg-hover)',
                                        color: 'var(--color-text-secondary)',
                                        fontSize: '11px',
                                        fontWeight: 600,
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '4px',
                                      }}
                                    >
                                      <span style={{ color: 'var(--color-secondary)', fontSize: '10px' }}>✓</span>
                                      {et.nombre} <span style={{ opacity: 0.75 }}>incluido</span>
                                    </span>
                                  );
                                }
                                return (
                                  <button
                                    key={et.id}
                                    onClick={() => toggleEtiquetaCombo(it.codigo_producto, it._instancia, et)}
                                    style={{
                                      padding: '5px 10px',
                                      borderRadius: '20px',
                                      border: `1px solid ${sel ? 'var(--color-secondary)' : 'var(--color-border)'}`,
                                      background: sel ? 'var(--color-bg-hover)' : 'var(--color-surface)',
                                      color: sel ? 'var(--color-secondary)' : 'var(--color-text-secondary)',
                                      fontSize: '11px',
                                      fontWeight: sel ? 700 : 500,
                                      cursor: 'pointer',
                                      fontFamily: 'inherit',
                                    }}
                                  >
                                    {et.nombre}
                                    {et.precio > 0 ? ` (+$${fmtMonto(et.precio)})` : ''}
                                  </button>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      );
                    });
                  })}
                </div>

                <div style={S.detailActions}>
                  <button
                    onClick={agregarComboPersonalizado}
                    disabled={agregandoCombo === comboDetalle.id}
                    style={{ ...S.addBtn, opacity: agregandoCombo === comboDetalle.id ? 0.6 : 1 }}
                  >
                    <FiPlus size={18} />
                    {agregandoCombo === comboDetalle.id
                      ? 'Agregando...'
                      : extra > 0
                        ? `Agregar al pedido · ${fmtMonto(totalCombo)}`
                        : `Agregar al pedido · $${fmtMonto(comboDetalle.precio)}`}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}

      {verCargarOrdenCompra && (
        <CargarOrdenCompra
          sessionId={sessionId}
          schemaName={schemaName}
          onClose={() => setVerCargarOrdenCompra(false)}
          onCompletado={(data) => {
            setVerCargarOrdenCompra(false);
            if (onPedidoCreado) onPedidoCreado();
            if (data && data.pedidos && data.pedidos.length) {
              if (onConfirmarPedido) onConfirmarPedido(data.pedidos[0].id);
            }
          }}
        />
      )}
    </div>
  );
}

ClienteCatalogo.displayName = 'ClienteCatalogo';

export default ClienteCatalogo;
export { cssAnimations };
